import{a as e,b,d as x,e as m,f as l,g as d,h as s,i as n,j as h}from"./ids-chunk-A3JFJPYO.js";import{a as u,b as y}from"./ids-chunk-XE4WFW5M.js";import{a as c}from"./ids-chunk-EV6LM7KM.js";import{e as r}from"./ids-chunk-5Q3WPKMB.js";import{a as t}from"./ids-chunk-4O5N6MTO.js";import{a as g}from"./ids-chunk-Y32WUP63.js";var p=`/* Host Variables */
:host {
  --grid-auto-row-height: 0;
  --grid-fill-color: var(--ids-layout-grid-color-background);
  --grid-text-color: var(--ids-layout-grid-color-text);
  --min-col-width: 0;
  --max-col-width: 1fr;
  --min-row-height: 0;
  --min-row-width: 1fr;
  --sticky-position: 0;
}

/* Grid Variables */
/* Host and ids-layout-grid Base */
:host,
.ids-layout-grid {
  display: grid;
  grid-gap: 16px;
  justify-content: start;
  box-sizing: border-box;
}

/* Grid Columms - Base */
:host([cols="1"]),
.ids-layout-grid-cols-1 {
  width: 100%;
  grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="1"]),
.ids-layout-grid > .ids-layout-grid-col-span-1 {
  grid-column: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([col-start="1"]),
.ids-layout-grid > .ids-layout-grid-col-start-1 {
  grid-column-start: 1;
}

:host(.ids-layout-grid) > ::slotted([col-end="1"]),
.ids-layout-grid > .ids-layout-grid-col-end-1 {
  grid-column-end: 1;
}

:host([cols="2"]),
.ids-layout-grid-cols-2 {
  width: 100%;
  grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="2"]),
.ids-layout-grid > .ids-layout-grid-col-span-2 {
  grid-column: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([col-start="2"]),
.ids-layout-grid > .ids-layout-grid-col-start-2 {
  grid-column-start: 2;
}

:host(.ids-layout-grid) > ::slotted([col-end="2"]),
.ids-layout-grid > .ids-layout-grid-col-end-2 {
  grid-column-end: 2;
}

:host([cols="3"]),
.ids-layout-grid-cols-3 {
  width: 100%;
  grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="3"]),
.ids-layout-grid > .ids-layout-grid-col-span-3 {
  grid-column: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([col-start="3"]),
.ids-layout-grid > .ids-layout-grid-col-start-3 {
  grid-column-start: 3;
}

:host(.ids-layout-grid) > ::slotted([col-end="3"]),
.ids-layout-grid > .ids-layout-grid-col-end-3 {
  grid-column-end: 3;
}

:host([cols="4"]),
.ids-layout-grid-cols-4 {
  width: 100%;
  grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="4"]),
.ids-layout-grid > .ids-layout-grid-col-span-4 {
  grid-column: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([col-start="4"]),
.ids-layout-grid > .ids-layout-grid-col-start-4 {
  grid-column-start: 4;
}

:host(.ids-layout-grid) > ::slotted([col-end="4"]),
.ids-layout-grid > .ids-layout-grid-col-end-4 {
  grid-column-end: 4;
}

:host([cols="5"]),
.ids-layout-grid-cols-5 {
  width: 100%;
  grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="5"]),
.ids-layout-grid > .ids-layout-grid-col-span-5 {
  grid-column: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([col-start="5"]),
.ids-layout-grid > .ids-layout-grid-col-start-5 {
  grid-column-start: 5;
}

:host(.ids-layout-grid) > ::slotted([col-end="5"]),
.ids-layout-grid > .ids-layout-grid-col-end-5 {
  grid-column-end: 5;
}

:host([cols="6"]),
.ids-layout-grid-cols-6 {
  width: 100%;
  grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="6"]),
.ids-layout-grid > .ids-layout-grid-col-span-6 {
  grid-column: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([col-start="6"]),
.ids-layout-grid > .ids-layout-grid-col-start-6 {
  grid-column-start: 6;
}

:host(.ids-layout-grid) > ::slotted([col-end="6"]),
.ids-layout-grid > .ids-layout-grid-col-end-6 {
  grid-column-end: 6;
}

:host([cols="7"]),
.ids-layout-grid-cols-7 {
  width: 100%;
  grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="7"]),
.ids-layout-grid > .ids-layout-grid-col-span-7 {
  grid-column: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([col-start="7"]),
.ids-layout-grid > .ids-layout-grid-col-start-7 {
  grid-column-start: 7;
}

:host(.ids-layout-grid) > ::slotted([col-end="7"]),
.ids-layout-grid > .ids-layout-grid-col-end-7 {
  grid-column-end: 7;
}

:host([cols="8"]),
.ids-layout-grid-cols-8 {
  width: 100%;
  grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="8"]),
.ids-layout-grid > .ids-layout-grid-col-span-8 {
  grid-column: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([col-start="8"]),
.ids-layout-grid > .ids-layout-grid-col-start-8 {
  grid-column-start: 8;
}

:host(.ids-layout-grid) > ::slotted([col-end="8"]),
.ids-layout-grid > .ids-layout-grid-col-end-8 {
  grid-column-end: 8;
}

:host([cols="9"]),
.ids-layout-grid-cols-9 {
  width: 100%;
  grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="9"]),
.ids-layout-grid > .ids-layout-grid-col-span-9 {
  grid-column: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([col-start="9"]),
.ids-layout-grid > .ids-layout-grid-col-start-9 {
  grid-column-start: 9;
}

:host(.ids-layout-grid) > ::slotted([col-end="9"]),
.ids-layout-grid > .ids-layout-grid-col-end-9 {
  grid-column-end: 9;
}

:host([cols="10"]),
.ids-layout-grid-cols-10 {
  width: 100%;
  grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="10"]),
.ids-layout-grid > .ids-layout-grid-col-span-10 {
  grid-column: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([col-start="10"]),
.ids-layout-grid > .ids-layout-grid-col-start-10 {
  grid-column-start: 10;
}

:host(.ids-layout-grid) > ::slotted([col-end="10"]),
.ids-layout-grid > .ids-layout-grid-col-end-10 {
  grid-column-end: 10;
}

:host([cols="11"]),
.ids-layout-grid-cols-11 {
  width: 100%;
  grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="11"]),
.ids-layout-grid > .ids-layout-grid-col-span-11 {
  grid-column: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([col-start="11"]),
.ids-layout-grid > .ids-layout-grid-col-start-11 {
  grid-column-start: 11;
}

:host(.ids-layout-grid) > ::slotted([col-end="11"]),
.ids-layout-grid > .ids-layout-grid-col-end-11 {
  grid-column-end: 11;
}

:host([cols="12"]),
.ids-layout-grid-cols-12 {
  width: 100%;
  grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="12"]),
.ids-layout-grid > .ids-layout-grid-col-span-12 {
  grid-column: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([col-start="12"]),
.ids-layout-grid > .ids-layout-grid-col-start-12 {
  grid-column-start: 12;
}

:host(.ids-layout-grid) > ::slotted([col-end="12"]),
.ids-layout-grid > .ids-layout-grid-col-end-12 {
  grid-column-end: 12;
}

:host([cols="13"]),
.ids-layout-grid-cols-13 {
  width: 100%;
  grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="13"]),
.ids-layout-grid > .ids-layout-grid-col-span-13 {
  grid-column: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([col-start="13"]),
.ids-layout-grid > .ids-layout-grid-col-start-13 {
  grid-column-start: 13;
}

:host(.ids-layout-grid) > ::slotted([col-end="13"]),
.ids-layout-grid > .ids-layout-grid-col-end-13 {
  grid-column-end: 13;
}

:host([cols="14"]),
.ids-layout-grid-cols-14 {
  width: 100%;
  grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="14"]),
.ids-layout-grid > .ids-layout-grid-col-span-14 {
  grid-column: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([col-start="14"]),
.ids-layout-grid > .ids-layout-grid-col-start-14 {
  grid-column-start: 14;
}

:host(.ids-layout-grid) > ::slotted([col-end="14"]),
.ids-layout-grid > .ids-layout-grid-col-end-14 {
  grid-column-end: 14;
}

:host([cols="15"]),
.ids-layout-grid-cols-15 {
  width: 100%;
  grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="15"]),
.ids-layout-grid > .ids-layout-grid-col-span-15 {
  grid-column: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([col-start="15"]),
.ids-layout-grid > .ids-layout-grid-col-start-15 {
  grid-column-start: 15;
}

:host(.ids-layout-grid) > ::slotted([col-end="15"]),
.ids-layout-grid > .ids-layout-grid-col-end-15 {
  grid-column-end: 15;
}

:host([cols="16"]),
.ids-layout-grid-cols-16 {
  width: 100%;
  grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="16"]),
.ids-layout-grid > .ids-layout-grid-col-span-16 {
  grid-column: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([col-start="16"]),
.ids-layout-grid > .ids-layout-grid-col-start-16 {
  grid-column-start: 16;
}

:host(.ids-layout-grid) > ::slotted([col-end="16"]),
.ids-layout-grid > .ids-layout-grid-col-end-16 {
  grid-column-end: 16;
}

:host([cols="17"]),
.ids-layout-grid-cols-17 {
  width: 100%;
  grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="17"]),
.ids-layout-grid > .ids-layout-grid-col-span-17 {
  grid-column: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([col-start="17"]),
.ids-layout-grid > .ids-layout-grid-col-start-17 {
  grid-column-start: 17;
}

:host(.ids-layout-grid) > ::slotted([col-end="17"]),
.ids-layout-grid > .ids-layout-grid-col-end-17 {
  grid-column-end: 17;
}

:host([cols="18"]),
.ids-layout-grid-cols-18 {
  width: 100%;
  grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="18"]),
.ids-layout-grid > .ids-layout-grid-col-span-18 {
  grid-column: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([col-start="18"]),
.ids-layout-grid > .ids-layout-grid-col-start-18 {
  grid-column-start: 18;
}

:host(.ids-layout-grid) > ::slotted([col-end="18"]),
.ids-layout-grid > .ids-layout-grid-col-end-18 {
  grid-column-end: 18;
}

:host([cols="19"]),
.ids-layout-grid-cols-19 {
  width: 100%;
  grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="19"]),
.ids-layout-grid > .ids-layout-grid-col-span-19 {
  grid-column: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([col-start="19"]),
.ids-layout-grid > .ids-layout-grid-col-start-19 {
  grid-column-start: 19;
}

:host(.ids-layout-grid) > ::slotted([col-end="19"]),
.ids-layout-grid > .ids-layout-grid-col-end-19 {
  grid-column-end: 19;
}

:host([cols="20"]),
.ids-layout-grid-cols-20 {
  width: 100%;
  grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="20"]),
.ids-layout-grid > .ids-layout-grid-col-span-20 {
  grid-column: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([col-start="20"]),
.ids-layout-grid > .ids-layout-grid-col-start-20 {
  grid-column-start: 20;
}

:host(.ids-layout-grid) > ::slotted([col-end="20"]),
.ids-layout-grid > .ids-layout-grid-col-end-20 {
  grid-column-end: 20;
}

:host([cols="21"]),
.ids-layout-grid-cols-21 {
  width: 100%;
  grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="21"]),
.ids-layout-grid > .ids-layout-grid-col-span-21 {
  grid-column: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([col-start="21"]),
.ids-layout-grid > .ids-layout-grid-col-start-21 {
  grid-column-start: 21;
}

:host(.ids-layout-grid) > ::slotted([col-end="21"]),
.ids-layout-grid > .ids-layout-grid-col-end-21 {
  grid-column-end: 21;
}

:host([cols="22"]),
.ids-layout-grid-cols-22 {
  width: 100%;
  grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="22"]),
.ids-layout-grid > .ids-layout-grid-col-span-22 {
  grid-column: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([col-start="22"]),
.ids-layout-grid > .ids-layout-grid-col-start-22 {
  grid-column-start: 22;
}

:host(.ids-layout-grid) > ::slotted([col-end="22"]),
.ids-layout-grid > .ids-layout-grid-col-end-22 {
  grid-column-end: 22;
}

:host([cols="23"]),
.ids-layout-grid-cols-23 {
  width: 100%;
  grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="23"]),
.ids-layout-grid > .ids-layout-grid-col-span-23 {
  grid-column: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([col-start="23"]),
.ids-layout-grid > .ids-layout-grid-col-start-23 {
  grid-column-start: 23;
}

:host(.ids-layout-grid) > ::slotted([col-end="23"]),
.ids-layout-grid > .ids-layout-grid-col-end-23 {
  grid-column-end: 23;
}

:host([cols="24"]),
.ids-layout-grid-cols-24 {
  width: 100%;
  grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="24"]),
.ids-layout-grid > .ids-layout-grid-col-span-24 {
  grid-column: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([col-start="24"]),
.ids-layout-grid > .ids-layout-grid-col-start-24 {
  grid-column-start: 24;
}

:host(.ids-layout-grid) > ::slotted([col-end="24"]),
.ids-layout-grid > .ids-layout-grid-col-end-24 {
  grid-column-end: 24;
}

/* Grid Rows - Base */
:host([rows="1"]),
.ids-layout-grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="1"]),
.ids-layout-grid > .ids-layout-grid-row-span-1 {
  grid-row: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([order="1"]),
.ids-layout-grid > .ids-layout-grid-order-1 {
  order: 1;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="2"]),
.ids-layout-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="2"]),
.ids-layout-grid > .ids-layout-grid-row-span-2 {
  grid-row: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([order="2"]),
.ids-layout-grid > .ids-layout-grid-order-2 {
  order: 2;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="3"]),
.ids-layout-grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="3"]),
.ids-layout-grid > .ids-layout-grid-row-span-3 {
  grid-row: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([order="3"]),
.ids-layout-grid > .ids-layout-grid-order-3 {
  order: 3;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="4"]),
.ids-layout-grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="4"]),
.ids-layout-grid > .ids-layout-grid-row-span-4 {
  grid-row: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([order="4"]),
.ids-layout-grid > .ids-layout-grid-order-4 {
  order: 4;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="5"]),
.ids-layout-grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="5"]),
.ids-layout-grid > .ids-layout-grid-row-span-5 {
  grid-row: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([order="5"]),
.ids-layout-grid > .ids-layout-grid-order-5 {
  order: 5;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="6"]),
.ids-layout-grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="6"]),
.ids-layout-grid > .ids-layout-grid-row-span-6 {
  grid-row: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([order="6"]),
.ids-layout-grid > .ids-layout-grid-order-6 {
  order: 6;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="7"]),
.ids-layout-grid-rows-7 {
  grid-template-rows: repeat(7, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="7"]),
.ids-layout-grid > .ids-layout-grid-row-span-7 {
  grid-row: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([order="7"]),
.ids-layout-grid > .ids-layout-grid-order-7 {
  order: 7;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="8"]),
.ids-layout-grid-rows-8 {
  grid-template-rows: repeat(8, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="8"]),
.ids-layout-grid > .ids-layout-grid-row-span-8 {
  grid-row: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([order="8"]),
.ids-layout-grid > .ids-layout-grid-order-8 {
  order: 8;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="9"]),
.ids-layout-grid-rows-9 {
  grid-template-rows: repeat(9, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="9"]),
.ids-layout-grid > .ids-layout-grid-row-span-9 {
  grid-row: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([order="9"]),
.ids-layout-grid > .ids-layout-grid-order-9 {
  order: 9;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="10"]),
.ids-layout-grid-rows-10 {
  grid-template-rows: repeat(10, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="10"]),
.ids-layout-grid > .ids-layout-grid-row-span-10 {
  grid-row: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([order="10"]),
.ids-layout-grid > .ids-layout-grid-order-10 {
  order: 10;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="11"]),
.ids-layout-grid-rows-11 {
  grid-template-rows: repeat(11, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="11"]),
.ids-layout-grid > .ids-layout-grid-row-span-11 {
  grid-row: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([order="11"]),
.ids-layout-grid > .ids-layout-grid-order-11 {
  order: 11;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="12"]),
.ids-layout-grid-rows-12 {
  grid-template-rows: repeat(12, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="12"]),
.ids-layout-grid > .ids-layout-grid-row-span-12 {
  grid-row: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([order="12"]),
.ids-layout-grid > .ids-layout-grid-order-12 {
  order: 12;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="13"]),
.ids-layout-grid-rows-13 {
  grid-template-rows: repeat(13, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="13"]),
.ids-layout-grid > .ids-layout-grid-row-span-13 {
  grid-row: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([order="13"]),
.ids-layout-grid > .ids-layout-grid-order-13 {
  order: 13;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="14"]),
.ids-layout-grid-rows-14 {
  grid-template-rows: repeat(14, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="14"]),
.ids-layout-grid > .ids-layout-grid-row-span-14 {
  grid-row: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([order="14"]),
.ids-layout-grid > .ids-layout-grid-order-14 {
  order: 14;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="15"]),
.ids-layout-grid-rows-15 {
  grid-template-rows: repeat(15, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="15"]),
.ids-layout-grid > .ids-layout-grid-row-span-15 {
  grid-row: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([order="15"]),
.ids-layout-grid > .ids-layout-grid-order-15 {
  order: 15;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="16"]),
.ids-layout-grid-rows-16 {
  grid-template-rows: repeat(16, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="16"]),
.ids-layout-grid > .ids-layout-grid-row-span-16 {
  grid-row: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([order="16"]),
.ids-layout-grid > .ids-layout-grid-order-16 {
  order: 16;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="17"]),
.ids-layout-grid-rows-17 {
  grid-template-rows: repeat(17, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="17"]),
.ids-layout-grid > .ids-layout-grid-row-span-17 {
  grid-row: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([order="17"]),
.ids-layout-grid > .ids-layout-grid-order-17 {
  order: 17;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="18"]),
.ids-layout-grid-rows-18 {
  grid-template-rows: repeat(18, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="18"]),
.ids-layout-grid > .ids-layout-grid-row-span-18 {
  grid-row: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([order="18"]),
.ids-layout-grid > .ids-layout-grid-order-18 {
  order: 18;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="19"]),
.ids-layout-grid-rows-19 {
  grid-template-rows: repeat(19, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="19"]),
.ids-layout-grid > .ids-layout-grid-row-span-19 {
  grid-row: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([order="19"]),
.ids-layout-grid > .ids-layout-grid-order-19 {
  order: 19;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="20"]),
.ids-layout-grid-rows-20 {
  grid-template-rows: repeat(20, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="20"]),
.ids-layout-grid > .ids-layout-grid-row-span-20 {
  grid-row: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([order="20"]),
.ids-layout-grid > .ids-layout-grid-order-20 {
  order: 20;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="21"]),
.ids-layout-grid-rows-21 {
  grid-template-rows: repeat(21, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="21"]),
.ids-layout-grid > .ids-layout-grid-row-span-21 {
  grid-row: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([order="21"]),
.ids-layout-grid > .ids-layout-grid-order-21 {
  order: 21;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="22"]),
.ids-layout-grid-rows-22 {
  grid-template-rows: repeat(22, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="22"]),
.ids-layout-grid > .ids-layout-grid-row-span-22 {
  grid-row: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([order="22"]),
.ids-layout-grid > .ids-layout-grid-order-22 {
  order: 22;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="23"]),
.ids-layout-grid-rows-23 {
  grid-template-rows: repeat(23, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="23"]),
.ids-layout-grid > .ids-layout-grid-row-span-23 {
  grid-row: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([order="23"]),
.ids-layout-grid > .ids-layout-grid-order-23 {
  order: 23;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="24"]),
.ids-layout-grid-rows-24 {
  grid-template-rows: repeat(24, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="24"]),
.ids-layout-grid > .ids-layout-grid-row-span-24 {
  grid-row: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([order="24"]),
.ids-layout-grid > .ids-layout-grid-order-24 {
  order: 24;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="25"]),
.ids-layout-grid-rows-25 {
  grid-template-rows: repeat(25, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="25"]),
.ids-layout-grid > .ids-layout-grid-row-span-25 {
  grid-row: span 25/span 25;
}

:host(.ids-layout-grid) > ::slotted([order="25"]),
.ids-layout-grid > .ids-layout-grid-order-25 {
  order: 25;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="26"]),
.ids-layout-grid-rows-26 {
  grid-template-rows: repeat(26, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="26"]),
.ids-layout-grid > .ids-layout-grid-row-span-26 {
  grid-row: span 26/span 26;
}

:host(.ids-layout-grid) > ::slotted([order="26"]),
.ids-layout-grid > .ids-layout-grid-order-26 {
  order: 26;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="27"]),
.ids-layout-grid-rows-27 {
  grid-template-rows: repeat(27, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="27"]),
.ids-layout-grid > .ids-layout-grid-row-span-27 {
  grid-row: span 27/span 27;
}

:host(.ids-layout-grid) > ::slotted([order="27"]),
.ids-layout-grid > .ids-layout-grid-order-27 {
  order: 27;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="28"]),
.ids-layout-grid-rows-28 {
  grid-template-rows: repeat(28, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="28"]),
.ids-layout-grid > .ids-layout-grid-row-span-28 {
  grid-row: span 28/span 28;
}

:host(.ids-layout-grid) > ::slotted([order="28"]),
.ids-layout-grid > .ids-layout-grid-order-28 {
  order: 28;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="29"]),
.ids-layout-grid-rows-29 {
  grid-template-rows: repeat(29, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="29"]),
.ids-layout-grid > .ids-layout-grid-row-span-29 {
  grid-row: span 29/span 29;
}

:host(.ids-layout-grid) > ::slotted([order="29"]),
.ids-layout-grid > .ids-layout-grid-order-29 {
  order: 29;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="30"]),
.ids-layout-grid-rows-30 {
  grid-template-rows: repeat(30, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="30"]),
.ids-layout-grid > .ids-layout-grid-row-span-30 {
  grid-row: span 30/span 30;
}

:host(.ids-layout-grid) > ::slotted([order="30"]),
.ids-layout-grid > .ids-layout-grid-order-30 {
  order: 30;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="31"]),
.ids-layout-grid-rows-31 {
  grid-template-rows: repeat(31, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="31"]),
.ids-layout-grid > .ids-layout-grid-row-span-31 {
  grid-row: span 31/span 31;
}

:host(.ids-layout-grid) > ::slotted([order="31"]),
.ids-layout-grid > .ids-layout-grid-order-31 {
  order: 31;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="32"]),
.ids-layout-grid-rows-32 {
  grid-template-rows: repeat(32, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="32"]),
.ids-layout-grid > .ids-layout-grid-row-span-32 {
  grid-row: span 32/span 32;
}

:host(.ids-layout-grid) > ::slotted([order="32"]),
.ids-layout-grid > .ids-layout-grid-order-32 {
  order: 32;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="33"]),
.ids-layout-grid-rows-33 {
  grid-template-rows: repeat(33, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="33"]),
.ids-layout-grid > .ids-layout-grid-row-span-33 {
  grid-row: span 33/span 33;
}

:host(.ids-layout-grid) > ::slotted([order="33"]),
.ids-layout-grid > .ids-layout-grid-order-33 {
  order: 33;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="34"]),
.ids-layout-grid-rows-34 {
  grid-template-rows: repeat(34, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="34"]),
.ids-layout-grid > .ids-layout-grid-row-span-34 {
  grid-row: span 34/span 34;
}

:host(.ids-layout-grid) > ::slotted([order="34"]),
.ids-layout-grid > .ids-layout-grid-order-34 {
  order: 34;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="35"]),
.ids-layout-grid-rows-35 {
  grid-template-rows: repeat(35, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="35"]),
.ids-layout-grid > .ids-layout-grid-row-span-35 {
  grid-row: span 35/span 35;
}

:host(.ids-layout-grid) > ::slotted([order="35"]),
.ids-layout-grid > .ids-layout-grid-order-35 {
  order: 35;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="36"]),
.ids-layout-grid-rows-36 {
  grid-template-rows: repeat(36, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="36"]),
.ids-layout-grid > .ids-layout-grid-row-span-36 {
  grid-row: span 36/span 36;
}

:host(.ids-layout-grid) > ::slotted([order="36"]),
.ids-layout-grid > .ids-layout-grid-order-36 {
  order: 36;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="37"]),
.ids-layout-grid-rows-37 {
  grid-template-rows: repeat(37, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="37"]),
.ids-layout-grid > .ids-layout-grid-row-span-37 {
  grid-row: span 37/span 37;
}

:host(.ids-layout-grid) > ::slotted([order="37"]),
.ids-layout-grid > .ids-layout-grid-order-37 {
  order: 37;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="38"]),
.ids-layout-grid-rows-38 {
  grid-template-rows: repeat(38, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="38"]),
.ids-layout-grid > .ids-layout-grid-row-span-38 {
  grid-row: span 38/span 38;
}

:host(.ids-layout-grid) > ::slotted([order="38"]),
.ids-layout-grid > .ids-layout-grid-order-38 {
  order: 38;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="39"]),
.ids-layout-grid-rows-39 {
  grid-template-rows: repeat(39, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="39"]),
.ids-layout-grid > .ids-layout-grid-row-span-39 {
  grid-row: span 39/span 39;
}

:host(.ids-layout-grid) > ::slotted([order="39"]),
.ids-layout-grid > .ids-layout-grid-order-39 {
  order: 39;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="40"]),
.ids-layout-grid-rows-40 {
  grid-template-rows: repeat(40, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="40"]),
.ids-layout-grid > .ids-layout-grid-row-span-40 {
  grid-row: span 40/span 40;
}

:host(.ids-layout-grid) > ::slotted([order="40"]),
.ids-layout-grid > .ids-layout-grid-order-40 {
  order: 40;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="41"]),
.ids-layout-grid-rows-41 {
  grid-template-rows: repeat(41, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="41"]),
.ids-layout-grid > .ids-layout-grid-row-span-41 {
  grid-row: span 41/span 41;
}

:host(.ids-layout-grid) > ::slotted([order="41"]),
.ids-layout-grid > .ids-layout-grid-order-41 {
  order: 41;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="42"]),
.ids-layout-grid-rows-42 {
  grid-template-rows: repeat(42, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="42"]),
.ids-layout-grid > .ids-layout-grid-row-span-42 {
  grid-row: span 42/span 42;
}

:host(.ids-layout-grid) > ::slotted([order="42"]),
.ids-layout-grid > .ids-layout-grid-order-42 {
  order: 42;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="43"]),
.ids-layout-grid-rows-43 {
  grid-template-rows: repeat(43, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="43"]),
.ids-layout-grid > .ids-layout-grid-row-span-43 {
  grid-row: span 43/span 43;
}

:host(.ids-layout-grid) > ::slotted([order="43"]),
.ids-layout-grid > .ids-layout-grid-order-43 {
  order: 43;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="44"]),
.ids-layout-grid-rows-44 {
  grid-template-rows: repeat(44, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="44"]),
.ids-layout-grid > .ids-layout-grid-row-span-44 {
  grid-row: span 44/span 44;
}

:host(.ids-layout-grid) > ::slotted([order="44"]),
.ids-layout-grid > .ids-layout-grid-order-44 {
  order: 44;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="45"]),
.ids-layout-grid-rows-45 {
  grid-template-rows: repeat(45, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="45"]),
.ids-layout-grid > .ids-layout-grid-row-span-45 {
  grid-row: span 45/span 45;
}

:host(.ids-layout-grid) > ::slotted([order="45"]),
.ids-layout-grid > .ids-layout-grid-order-45 {
  order: 45;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="46"]),
.ids-layout-grid-rows-46 {
  grid-template-rows: repeat(46, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="46"]),
.ids-layout-grid > .ids-layout-grid-row-span-46 {
  grid-row: span 46/span 46;
}

:host(.ids-layout-grid) > ::slotted([order="46"]),
.ids-layout-grid > .ids-layout-grid-order-46 {
  order: 46;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="47"]),
.ids-layout-grid-rows-47 {
  grid-template-rows: repeat(47, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="47"]),
.ids-layout-grid > .ids-layout-grid-row-span-47 {
  grid-row: span 47/span 47;
}

:host(.ids-layout-grid) > ::slotted([order="47"]),
.ids-layout-grid > .ids-layout-grid-order-47 {
  order: 47;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="48"]),
.ids-layout-grid-rows-48 {
  grid-template-rows: repeat(48, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="48"]),
.ids-layout-grid > .ids-layout-grid-row-span-48 {
  grid-row: span 48/span 48;
}

:host(.ids-layout-grid) > ::slotted([order="48"]),
.ids-layout-grid > .ids-layout-grid-order-48 {
  order: 48;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="49"]),
.ids-layout-grid-rows-49 {
  grid-template-rows: repeat(49, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="49"]),
.ids-layout-grid > .ids-layout-grid-row-span-49 {
  grid-row: span 49/span 49;
}

:host(.ids-layout-grid) > ::slotted([order="49"]),
.ids-layout-grid > .ids-layout-grid-order-49 {
  order: 49;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="50"]),
.ids-layout-grid-rows-50 {
  grid-template-rows: repeat(50, minmax(0, 1fr));
}

:host(.ids-layout-grid) > ::slotted([row-span="50"]),
.ids-layout-grid > .ids-layout-grid-row-span-50 {
  grid-row: span 50/span 50;
}

:host(.ids-layout-grid) > ::slotted([order="50"]),
.ids-layout-grid > .ids-layout-grid-order-50 {
  order: 50;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

@media (min-width: 360px) {
  :host([cols-xs="1"]),
  .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="2"]),
  .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="3"]),
  .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="4"]),
  .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="5"]),
  .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="6"]),
  .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="7"]),
  .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="8"]),
  .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="9"]),
  .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="10"]),
  .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="11"]),
  .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="12"]),
  .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="13"]),
  .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="14"]),
  .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="15"]),
  .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="16"]),
  .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="17"]),
  .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="18"]),
  .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="19"]),
  .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="20"]),
  .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="21"]),
  .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="22"]),
  .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="23"]),
  .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="24"]),
  .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xs=row]),
  .ids-layout-grid-flow-xs-row {
    grid-auto-flow: row;
  }
  :host([flow-xs=column]),
  .ids-layout-grid-flow-xs-col {
    grid-auto-flow: column;
  }
  :host([flow-xs=dense]),
  .ids-layout-grid-flow-xs-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xs=row-dense]),
  .ids-layout-grid-flow-xs-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xs=column-dense]),
  .ids-layout-grid-flow-xs-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 600px) {
  :host([cols-sm="1"]),
  .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="2"]),
  .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="3"]),
  .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="4"]),
  .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="5"]),
  .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="6"]),
  .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="7"]),
  .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="8"]),
  .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="9"]),
  .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="10"]),
  .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="11"]),
  .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="12"]),
  .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="13"]),
  .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="14"]),
  .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="15"]),
  .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="16"]),
  .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="17"]),
  .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="18"]),
  .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="19"]),
  .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="20"]),
  .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="21"]),
  .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="22"]),
  .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="23"]),
  .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="24"]),
  .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-sm=row]),
  .ids-layout-grid-flow-sm-row {
    grid-auto-flow: row;
  }
  :host([flow-sm=column]),
  .ids-layout-grid-flow-sm-col {
    grid-auto-flow: column;
  }
  :host([flow-sm=dense]),
  .ids-layout-grid-flow-sm-dense {
    grid-auto-flow: dense;
  }
  :host([flow-sm=row-dense]),
  .ids-layout-grid-flow-sm-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-sm=column-dense]),
  .ids-layout-grid-flow-sm-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 840px) {
  :host([cols-md="1"]),
  .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="2"]),
  .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="3"]),
  .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="4"]),
  .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="5"]),
  .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="6"]),
  .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="7"]),
  .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="8"]),
  .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="9"]),
  .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="10"]),
  .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="11"]),
  .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="12"]),
  .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="13"]),
  .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="14"]),
  .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="15"]),
  .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="16"]),
  .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="17"]),
  .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="18"]),
  .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="19"]),
  .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="20"]),
  .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="21"]),
  .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="22"]),
  .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="23"]),
  .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="24"]),
  .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-md=row]),
  .ids-layout-grid-flow-md-row {
    grid-auto-flow: row;
  }
  :host([flow-md=column]),
  .ids-layout-grid-flow-md-col {
    grid-auto-flow: column;
  }
  :host([flow-md=dense]),
  .ids-layout-grid-flow-md-dense {
    grid-auto-flow: dense;
  }
  :host([flow-md=row-dense]),
  .ids-layout-grid-flow-md-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-md=column-dense]),
  .ids-layout-grid-flow-md-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1024px) {
  :host([cols-lg="1"]),
  .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="2"]),
  .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="3"]),
  .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="4"]),
  .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="5"]),
  .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="6"]),
  .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="7"]),
  .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="8"]),
  .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="9"]),
  .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="10"]),
  .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="11"]),
  .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="12"]),
  .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="13"]),
  .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="14"]),
  .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="15"]),
  .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="16"]),
  .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="17"]),
  .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="18"]),
  .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="19"]),
  .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="20"]),
  .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="21"]),
  .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="22"]),
  .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="23"]),
  .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="24"]),
  .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-lg=row]),
  .ids-layout-grid-flow-lg-row {
    grid-auto-flow: row;
  }
  :host([flow-lg=column]),
  .ids-layout-grid-flow-lg-col {
    grid-auto-flow: column;
  }
  :host([flow-lg=dense]),
  .ids-layout-grid-flow-lg-dense {
    grid-auto-flow: dense;
  }
  :host([flow-lg=row-dense]),
  .ids-layout-grid-flow-lg-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-lg=column-dense]),
  .ids-layout-grid-flow-lg-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1280px) {
  :host([cols-xl="1"]),
  .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="2"]),
  .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="3"]),
  .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="4"]),
  .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="5"]),
  .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="6"]),
  .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="7"]),
  .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="8"]),
  .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="9"]),
  .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="10"]),
  .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="11"]),
  .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="12"]),
  .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="13"]),
  .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="14"]),
  .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="15"]),
  .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="16"]),
  .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="17"]),
  .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="18"]),
  .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="19"]),
  .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="20"]),
  .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="21"]),
  .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="22"]),
  .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="23"]),
  .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="24"]),
  .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xl=row]),
  .ids-layout-grid-flow-xl-row {
    grid-auto-flow: row;
  }
  :host([flow-xl=column]),
  .ids-layout-grid-flow-xl-col {
    grid-auto-flow: column;
  }
  :host([flow-xl=dense]),
  .ids-layout-grid-flow-xl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xl=row-dense]),
  .ids-layout-grid-flow-xl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xl=column-dense]),
  .ids-layout-grid-flow-xl-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (min-width: 1440px) {
  :host([cols-xxl="1"]),
  .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="2"]),
  .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="3"]),
  .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="4"]),
  .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="5"]),
  .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="6"]),
  .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="7"]),
  .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="8"]),
  .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="9"]),
  .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="10"]),
  .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="11"]),
  .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="12"]),
  .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="13"]),
  .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="14"]),
  .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="15"]),
  .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="16"]),
  .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="17"]),
  .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="18"]),
  .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="19"]),
  .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="20"]),
  .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="21"]),
  .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="22"]),
  .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="23"]),
  .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="24"]),
  .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([flow-xxl=row]),
  .ids-layout-grid-flow-xxl-row {
    grid-auto-flow: row;
  }
  :host([flow-xxl=column]),
  .ids-layout-grid-flow-xxl-col {
    grid-auto-flow: column;
  }
  :host([flow-xxl=dense]),
  .ids-layout-grid-flow-xxl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xxl=row-dense]),
  .ids-layout-grid-flow-xxl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xxl=column-dense]),
  .ids-layout-grid-flow-xxl-col-dense {
    grid-auto-flow: column dense;
  }
}
/* Use media queries by default */
@media (min-width: 360px) {
  :host(:not([enable-container])) > ::slotted([col-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xs="1"], :host(:not([enable-container])).ids-layout-grid-rows-xs-1,
  .ids-layout-grid:not([enable-container])[rows-xs="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="2"], :host(:not([enable-container])).ids-layout-grid-rows-xs-2,
  .ids-layout-grid:not([enable-container])[rows-xs="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="3"], :host(:not([enable-container])).ids-layout-grid-rows-xs-3,
  .ids-layout-grid:not([enable-container])[rows-xs="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="4"], :host(:not([enable-container])).ids-layout-grid-rows-xs-4,
  .ids-layout-grid:not([enable-container])[rows-xs="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="5"], :host(:not([enable-container])).ids-layout-grid-rows-xs-5,
  .ids-layout-grid:not([enable-container])[rows-xs="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="6"], :host(:not([enable-container])).ids-layout-grid-rows-xs-6,
  .ids-layout-grid:not([enable-container])[rows-xs="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="7"], :host(:not([enable-container])).ids-layout-grid-rows-xs-7,
  .ids-layout-grid:not([enable-container])[rows-xs="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="8"], :host(:not([enable-container])).ids-layout-grid-rows-xs-8,
  .ids-layout-grid:not([enable-container])[rows-xs="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="9"], :host(:not([enable-container])).ids-layout-grid-rows-xs-9,
  .ids-layout-grid:not([enable-container])[rows-xs="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="10"], :host(:not([enable-container])).ids-layout-grid-rows-xs-10,
  .ids-layout-grid:not([enable-container])[rows-xs="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="11"], :host(:not([enable-container])).ids-layout-grid-rows-xs-11,
  .ids-layout-grid:not([enable-container])[rows-xs="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="12"], :host(:not([enable-container])).ids-layout-grid-rows-xs-12,
  .ids-layout-grid:not([enable-container])[rows-xs="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="13"], :host(:not([enable-container])).ids-layout-grid-rows-xs-13,
  .ids-layout-grid:not([enable-container])[rows-xs="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="14"], :host(:not([enable-container])).ids-layout-grid-rows-xs-14,
  .ids-layout-grid:not([enable-container])[rows-xs="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="15"], :host(:not([enable-container])).ids-layout-grid-rows-xs-15,
  .ids-layout-grid:not([enable-container])[rows-xs="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="16"], :host(:not([enable-container])).ids-layout-grid-rows-xs-16,
  .ids-layout-grid:not([enable-container])[rows-xs="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="17"], :host(:not([enable-container])).ids-layout-grid-rows-xs-17,
  .ids-layout-grid:not([enable-container])[rows-xs="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="18"], :host(:not([enable-container])).ids-layout-grid-rows-xs-18,
  .ids-layout-grid:not([enable-container])[rows-xs="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="19"], :host(:not([enable-container])).ids-layout-grid-rows-xs-19,
  .ids-layout-grid:not([enable-container])[rows-xs="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="20"], :host(:not([enable-container])).ids-layout-grid-rows-xs-20,
  .ids-layout-grid:not([enable-container])[rows-xs="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="21"], :host(:not([enable-container])).ids-layout-grid-rows-xs-21,
  .ids-layout-grid:not([enable-container])[rows-xs="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="22"], :host(:not([enable-container])).ids-layout-grid-rows-xs-22,
  .ids-layout-grid:not([enable-container])[rows-xs="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="23"], :host(:not([enable-container])).ids-layout-grid-rows-xs-23,
  .ids-layout-grid:not([enable-container])[rows-xs="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="24"], :host(:not([enable-container])).ids-layout-grid-rows-xs-24,
  .ids-layout-grid:not([enable-container])[rows-xs="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="25"], :host(:not([enable-container])).ids-layout-grid-rows-xs-25,
  .ids-layout-grid:not([enable-container])[rows-xs="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="26"], :host(:not([enable-container])).ids-layout-grid-rows-xs-26,
  .ids-layout-grid:not([enable-container])[rows-xs="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="27"], :host(:not([enable-container])).ids-layout-grid-rows-xs-27,
  .ids-layout-grid:not([enable-container])[rows-xs="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="28"], :host(:not([enable-container])).ids-layout-grid-rows-xs-28,
  .ids-layout-grid:not([enable-container])[rows-xs="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="29"], :host(:not([enable-container])).ids-layout-grid-rows-xs-29,
  .ids-layout-grid:not([enable-container])[rows-xs="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="30"], :host(:not([enable-container])).ids-layout-grid-rows-xs-30,
  .ids-layout-grid:not([enable-container])[rows-xs="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="31"], :host(:not([enable-container])).ids-layout-grid-rows-xs-31,
  .ids-layout-grid:not([enable-container])[rows-xs="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="32"], :host(:not([enable-container])).ids-layout-grid-rows-xs-32,
  .ids-layout-grid:not([enable-container])[rows-xs="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="33"], :host(:not([enable-container])).ids-layout-grid-rows-xs-33,
  .ids-layout-grid:not([enable-container])[rows-xs="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="34"], :host(:not([enable-container])).ids-layout-grid-rows-xs-34,
  .ids-layout-grid:not([enable-container])[rows-xs="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="35"], :host(:not([enable-container])).ids-layout-grid-rows-xs-35,
  .ids-layout-grid:not([enable-container])[rows-xs="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="36"], :host(:not([enable-container])).ids-layout-grid-rows-xs-36,
  .ids-layout-grid:not([enable-container])[rows-xs="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="37"], :host(:not([enable-container])).ids-layout-grid-rows-xs-37,
  .ids-layout-grid:not([enable-container])[rows-xs="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="38"], :host(:not([enable-container])).ids-layout-grid-rows-xs-38,
  .ids-layout-grid:not([enable-container])[rows-xs="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="39"], :host(:not([enable-container])).ids-layout-grid-rows-xs-39,
  .ids-layout-grid:not([enable-container])[rows-xs="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="40"], :host(:not([enable-container])).ids-layout-grid-rows-xs-40,
  .ids-layout-grid:not([enable-container])[rows-xs="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="41"], :host(:not([enable-container])).ids-layout-grid-rows-xs-41,
  .ids-layout-grid:not([enable-container])[rows-xs="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="42"], :host(:not([enable-container])).ids-layout-grid-rows-xs-42,
  .ids-layout-grid:not([enable-container])[rows-xs="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="43"], :host(:not([enable-container])).ids-layout-grid-rows-xs-43,
  .ids-layout-grid:not([enable-container])[rows-xs="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="44"], :host(:not([enable-container])).ids-layout-grid-rows-xs-44,
  .ids-layout-grid:not([enable-container])[rows-xs="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="45"], :host(:not([enable-container])).ids-layout-grid-rows-xs-45,
  .ids-layout-grid:not([enable-container])[rows-xs="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="46"], :host(:not([enable-container])).ids-layout-grid-rows-xs-46,
  .ids-layout-grid:not([enable-container])[rows-xs="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="47"], :host(:not([enable-container])).ids-layout-grid-rows-xs-47,
  .ids-layout-grid:not([enable-container])[rows-xs="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="48"], :host(:not([enable-container])).ids-layout-grid-rows-xs-48,
  .ids-layout-grid:not([enable-container])[rows-xs="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="49"], :host(:not([enable-container])).ids-layout-grid-rows-xs-49,
  .ids-layout-grid:not([enable-container])[rows-xs="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="50"], :host(:not([enable-container])).ids-layout-grid-rows-xs-50,
  .ids-layout-grid:not([enable-container])[rows-xs="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xs]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xs]) {
    display: block;
  }
}
@media (min-width: 600px) {
  :host(:not([enable-container])) > ::slotted([col-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-sm="1"], :host(:not([enable-container])).ids-layout-grid-rows-sm-1,
  .ids-layout-grid:not([enable-container])[rows-sm="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="2"], :host(:not([enable-container])).ids-layout-grid-rows-sm-2,
  .ids-layout-grid:not([enable-container])[rows-sm="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="3"], :host(:not([enable-container])).ids-layout-grid-rows-sm-3,
  .ids-layout-grid:not([enable-container])[rows-sm="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="4"], :host(:not([enable-container])).ids-layout-grid-rows-sm-4,
  .ids-layout-grid:not([enable-container])[rows-sm="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="5"], :host(:not([enable-container])).ids-layout-grid-rows-sm-5,
  .ids-layout-grid:not([enable-container])[rows-sm="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="6"], :host(:not([enable-container])).ids-layout-grid-rows-sm-6,
  .ids-layout-grid:not([enable-container])[rows-sm="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="7"], :host(:not([enable-container])).ids-layout-grid-rows-sm-7,
  .ids-layout-grid:not([enable-container])[rows-sm="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="8"], :host(:not([enable-container])).ids-layout-grid-rows-sm-8,
  .ids-layout-grid:not([enable-container])[rows-sm="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="9"], :host(:not([enable-container])).ids-layout-grid-rows-sm-9,
  .ids-layout-grid:not([enable-container])[rows-sm="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="10"], :host(:not([enable-container])).ids-layout-grid-rows-sm-10,
  .ids-layout-grid:not([enable-container])[rows-sm="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="11"], :host(:not([enable-container])).ids-layout-grid-rows-sm-11,
  .ids-layout-grid:not([enable-container])[rows-sm="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="12"], :host(:not([enable-container])).ids-layout-grid-rows-sm-12,
  .ids-layout-grid:not([enable-container])[rows-sm="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="13"], :host(:not([enable-container])).ids-layout-grid-rows-sm-13,
  .ids-layout-grid:not([enable-container])[rows-sm="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="14"], :host(:not([enable-container])).ids-layout-grid-rows-sm-14,
  .ids-layout-grid:not([enable-container])[rows-sm="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="15"], :host(:not([enable-container])).ids-layout-grid-rows-sm-15,
  .ids-layout-grid:not([enable-container])[rows-sm="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="16"], :host(:not([enable-container])).ids-layout-grid-rows-sm-16,
  .ids-layout-grid:not([enable-container])[rows-sm="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="17"], :host(:not([enable-container])).ids-layout-grid-rows-sm-17,
  .ids-layout-grid:not([enable-container])[rows-sm="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="18"], :host(:not([enable-container])).ids-layout-grid-rows-sm-18,
  .ids-layout-grid:not([enable-container])[rows-sm="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="19"], :host(:not([enable-container])).ids-layout-grid-rows-sm-19,
  .ids-layout-grid:not([enable-container])[rows-sm="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="20"], :host(:not([enable-container])).ids-layout-grid-rows-sm-20,
  .ids-layout-grid:not([enable-container])[rows-sm="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="21"], :host(:not([enable-container])).ids-layout-grid-rows-sm-21,
  .ids-layout-grid:not([enable-container])[rows-sm="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="22"], :host(:not([enable-container])).ids-layout-grid-rows-sm-22,
  .ids-layout-grid:not([enable-container])[rows-sm="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="23"], :host(:not([enable-container])).ids-layout-grid-rows-sm-23,
  .ids-layout-grid:not([enable-container])[rows-sm="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="24"], :host(:not([enable-container])).ids-layout-grid-rows-sm-24,
  .ids-layout-grid:not([enable-container])[rows-sm="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="25"], :host(:not([enable-container])).ids-layout-grid-rows-sm-25,
  .ids-layout-grid:not([enable-container])[rows-sm="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="26"], :host(:not([enable-container])).ids-layout-grid-rows-sm-26,
  .ids-layout-grid:not([enable-container])[rows-sm="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="27"], :host(:not([enable-container])).ids-layout-grid-rows-sm-27,
  .ids-layout-grid:not([enable-container])[rows-sm="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="28"], :host(:not([enable-container])).ids-layout-grid-rows-sm-28,
  .ids-layout-grid:not([enable-container])[rows-sm="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="29"], :host(:not([enable-container])).ids-layout-grid-rows-sm-29,
  .ids-layout-grid:not([enable-container])[rows-sm="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="30"], :host(:not([enable-container])).ids-layout-grid-rows-sm-30,
  .ids-layout-grid:not([enable-container])[rows-sm="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="31"], :host(:not([enable-container])).ids-layout-grid-rows-sm-31,
  .ids-layout-grid:not([enable-container])[rows-sm="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="32"], :host(:not([enable-container])).ids-layout-grid-rows-sm-32,
  .ids-layout-grid:not([enable-container])[rows-sm="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="33"], :host(:not([enable-container])).ids-layout-grid-rows-sm-33,
  .ids-layout-grid:not([enable-container])[rows-sm="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="34"], :host(:not([enable-container])).ids-layout-grid-rows-sm-34,
  .ids-layout-grid:not([enable-container])[rows-sm="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="35"], :host(:not([enable-container])).ids-layout-grid-rows-sm-35,
  .ids-layout-grid:not([enable-container])[rows-sm="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="36"], :host(:not([enable-container])).ids-layout-grid-rows-sm-36,
  .ids-layout-grid:not([enable-container])[rows-sm="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="37"], :host(:not([enable-container])).ids-layout-grid-rows-sm-37,
  .ids-layout-grid:not([enable-container])[rows-sm="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="38"], :host(:not([enable-container])).ids-layout-grid-rows-sm-38,
  .ids-layout-grid:not([enable-container])[rows-sm="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="39"], :host(:not([enable-container])).ids-layout-grid-rows-sm-39,
  .ids-layout-grid:not([enable-container])[rows-sm="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="40"], :host(:not([enable-container])).ids-layout-grid-rows-sm-40,
  .ids-layout-grid:not([enable-container])[rows-sm="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="41"], :host(:not([enable-container])).ids-layout-grid-rows-sm-41,
  .ids-layout-grid:not([enable-container])[rows-sm="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="42"], :host(:not([enable-container])).ids-layout-grid-rows-sm-42,
  .ids-layout-grid:not([enable-container])[rows-sm="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="43"], :host(:not([enable-container])).ids-layout-grid-rows-sm-43,
  .ids-layout-grid:not([enable-container])[rows-sm="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="44"], :host(:not([enable-container])).ids-layout-grid-rows-sm-44,
  .ids-layout-grid:not([enable-container])[rows-sm="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="45"], :host(:not([enable-container])).ids-layout-grid-rows-sm-45,
  .ids-layout-grid:not([enable-container])[rows-sm="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="46"], :host(:not([enable-container])).ids-layout-grid-rows-sm-46,
  .ids-layout-grid:not([enable-container])[rows-sm="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="47"], :host(:not([enable-container])).ids-layout-grid-rows-sm-47,
  .ids-layout-grid:not([enable-container])[rows-sm="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="48"], :host(:not([enable-container])).ids-layout-grid-rows-sm-48,
  .ids-layout-grid:not([enable-container])[rows-sm="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="49"], :host(:not([enable-container])).ids-layout-grid-rows-sm-49,
  .ids-layout-grid:not([enable-container])[rows-sm="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="50"], :host(:not([enable-container])).ids-layout-grid-rows-sm-50,
  .ids-layout-grid:not([enable-container])[rows-sm="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=sm]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=sm]) {
    display: block;
  }
}
@media (min-width: 840px) {
  :host(:not([enable-container])) > ::slotted([col-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-md="1"], :host(:not([enable-container])).ids-layout-grid-rows-md-1,
  .ids-layout-grid:not([enable-container])[rows-md="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="2"], :host(:not([enable-container])).ids-layout-grid-rows-md-2,
  .ids-layout-grid:not([enable-container])[rows-md="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="3"], :host(:not([enable-container])).ids-layout-grid-rows-md-3,
  .ids-layout-grid:not([enable-container])[rows-md="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="4"], :host(:not([enable-container])).ids-layout-grid-rows-md-4,
  .ids-layout-grid:not([enable-container])[rows-md="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="5"], :host(:not([enable-container])).ids-layout-grid-rows-md-5,
  .ids-layout-grid:not([enable-container])[rows-md="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="6"], :host(:not([enable-container])).ids-layout-grid-rows-md-6,
  .ids-layout-grid:not([enable-container])[rows-md="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="7"], :host(:not([enable-container])).ids-layout-grid-rows-md-7,
  .ids-layout-grid:not([enable-container])[rows-md="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="8"], :host(:not([enable-container])).ids-layout-grid-rows-md-8,
  .ids-layout-grid:not([enable-container])[rows-md="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="9"], :host(:not([enable-container])).ids-layout-grid-rows-md-9,
  .ids-layout-grid:not([enable-container])[rows-md="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="10"], :host(:not([enable-container])).ids-layout-grid-rows-md-10,
  .ids-layout-grid:not([enable-container])[rows-md="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="11"], :host(:not([enable-container])).ids-layout-grid-rows-md-11,
  .ids-layout-grid:not([enable-container])[rows-md="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="12"], :host(:not([enable-container])).ids-layout-grid-rows-md-12,
  .ids-layout-grid:not([enable-container])[rows-md="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="13"], :host(:not([enable-container])).ids-layout-grid-rows-md-13,
  .ids-layout-grid:not([enable-container])[rows-md="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="14"], :host(:not([enable-container])).ids-layout-grid-rows-md-14,
  .ids-layout-grid:not([enable-container])[rows-md="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="15"], :host(:not([enable-container])).ids-layout-grid-rows-md-15,
  .ids-layout-grid:not([enable-container])[rows-md="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="16"], :host(:not([enable-container])).ids-layout-grid-rows-md-16,
  .ids-layout-grid:not([enable-container])[rows-md="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="17"], :host(:not([enable-container])).ids-layout-grid-rows-md-17,
  .ids-layout-grid:not([enable-container])[rows-md="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="18"], :host(:not([enable-container])).ids-layout-grid-rows-md-18,
  .ids-layout-grid:not([enable-container])[rows-md="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="19"], :host(:not([enable-container])).ids-layout-grid-rows-md-19,
  .ids-layout-grid:not([enable-container])[rows-md="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="20"], :host(:not([enable-container])).ids-layout-grid-rows-md-20,
  .ids-layout-grid:not([enable-container])[rows-md="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="21"], :host(:not([enable-container])).ids-layout-grid-rows-md-21,
  .ids-layout-grid:not([enable-container])[rows-md="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="22"], :host(:not([enable-container])).ids-layout-grid-rows-md-22,
  .ids-layout-grid:not([enable-container])[rows-md="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="23"], :host(:not([enable-container])).ids-layout-grid-rows-md-23,
  .ids-layout-grid:not([enable-container])[rows-md="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="24"], :host(:not([enable-container])).ids-layout-grid-rows-md-24,
  .ids-layout-grid:not([enable-container])[rows-md="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="25"], :host(:not([enable-container])).ids-layout-grid-rows-md-25,
  .ids-layout-grid:not([enable-container])[rows-md="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="26"], :host(:not([enable-container])).ids-layout-grid-rows-md-26,
  .ids-layout-grid:not([enable-container])[rows-md="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="27"], :host(:not([enable-container])).ids-layout-grid-rows-md-27,
  .ids-layout-grid:not([enable-container])[rows-md="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="28"], :host(:not([enable-container])).ids-layout-grid-rows-md-28,
  .ids-layout-grid:not([enable-container])[rows-md="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="29"], :host(:not([enable-container])).ids-layout-grid-rows-md-29,
  .ids-layout-grid:not([enable-container])[rows-md="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="30"], :host(:not([enable-container])).ids-layout-grid-rows-md-30,
  .ids-layout-grid:not([enable-container])[rows-md="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="31"], :host(:not([enable-container])).ids-layout-grid-rows-md-31,
  .ids-layout-grid:not([enable-container])[rows-md="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="32"], :host(:not([enable-container])).ids-layout-grid-rows-md-32,
  .ids-layout-grid:not([enable-container])[rows-md="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="33"], :host(:not([enable-container])).ids-layout-grid-rows-md-33,
  .ids-layout-grid:not([enable-container])[rows-md="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="34"], :host(:not([enable-container])).ids-layout-grid-rows-md-34,
  .ids-layout-grid:not([enable-container])[rows-md="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="35"], :host(:not([enable-container])).ids-layout-grid-rows-md-35,
  .ids-layout-grid:not([enable-container])[rows-md="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="36"], :host(:not([enable-container])).ids-layout-grid-rows-md-36,
  .ids-layout-grid:not([enable-container])[rows-md="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="37"], :host(:not([enable-container])).ids-layout-grid-rows-md-37,
  .ids-layout-grid:not([enable-container])[rows-md="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="38"], :host(:not([enable-container])).ids-layout-grid-rows-md-38,
  .ids-layout-grid:not([enable-container])[rows-md="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="39"], :host(:not([enable-container])).ids-layout-grid-rows-md-39,
  .ids-layout-grid:not([enable-container])[rows-md="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="40"], :host(:not([enable-container])).ids-layout-grid-rows-md-40,
  .ids-layout-grid:not([enable-container])[rows-md="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="41"], :host(:not([enable-container])).ids-layout-grid-rows-md-41,
  .ids-layout-grid:not([enable-container])[rows-md="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="42"], :host(:not([enable-container])).ids-layout-grid-rows-md-42,
  .ids-layout-grid:not([enable-container])[rows-md="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="43"], :host(:not([enable-container])).ids-layout-grid-rows-md-43,
  .ids-layout-grid:not([enable-container])[rows-md="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="44"], :host(:not([enable-container])).ids-layout-grid-rows-md-44,
  .ids-layout-grid:not([enable-container])[rows-md="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="45"], :host(:not([enable-container])).ids-layout-grid-rows-md-45,
  .ids-layout-grid:not([enable-container])[rows-md="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="46"], :host(:not([enable-container])).ids-layout-grid-rows-md-46,
  .ids-layout-grid:not([enable-container])[rows-md="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="47"], :host(:not([enable-container])).ids-layout-grid-rows-md-47,
  .ids-layout-grid:not([enable-container])[rows-md="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="48"], :host(:not([enable-container])).ids-layout-grid-rows-md-48,
  .ids-layout-grid:not([enable-container])[rows-md="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="49"], :host(:not([enable-container])).ids-layout-grid-rows-md-49,
  .ids-layout-grid:not([enable-container])[rows-md="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="50"], :host(:not([enable-container])).ids-layout-grid-rows-md-50,
  .ids-layout-grid:not([enable-container])[rows-md="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=md]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=md]) {
    display: block;
  }
}
@media (min-width: 1024px) {
  :host(:not([enable-container])) > ::slotted([col-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-lg="1"], :host(:not([enable-container])).ids-layout-grid-rows-lg-1,
  .ids-layout-grid:not([enable-container])[rows-lg="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="2"], :host(:not([enable-container])).ids-layout-grid-rows-lg-2,
  .ids-layout-grid:not([enable-container])[rows-lg="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="3"], :host(:not([enable-container])).ids-layout-grid-rows-lg-3,
  .ids-layout-grid:not([enable-container])[rows-lg="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="4"], :host(:not([enable-container])).ids-layout-grid-rows-lg-4,
  .ids-layout-grid:not([enable-container])[rows-lg="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="5"], :host(:not([enable-container])).ids-layout-grid-rows-lg-5,
  .ids-layout-grid:not([enable-container])[rows-lg="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="6"], :host(:not([enable-container])).ids-layout-grid-rows-lg-6,
  .ids-layout-grid:not([enable-container])[rows-lg="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="7"], :host(:not([enable-container])).ids-layout-grid-rows-lg-7,
  .ids-layout-grid:not([enable-container])[rows-lg="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="8"], :host(:not([enable-container])).ids-layout-grid-rows-lg-8,
  .ids-layout-grid:not([enable-container])[rows-lg="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="9"], :host(:not([enable-container])).ids-layout-grid-rows-lg-9,
  .ids-layout-grid:not([enable-container])[rows-lg="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="10"], :host(:not([enable-container])).ids-layout-grid-rows-lg-10,
  .ids-layout-grid:not([enable-container])[rows-lg="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="11"], :host(:not([enable-container])).ids-layout-grid-rows-lg-11,
  .ids-layout-grid:not([enable-container])[rows-lg="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="12"], :host(:not([enable-container])).ids-layout-grid-rows-lg-12,
  .ids-layout-grid:not([enable-container])[rows-lg="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="13"], :host(:not([enable-container])).ids-layout-grid-rows-lg-13,
  .ids-layout-grid:not([enable-container])[rows-lg="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="14"], :host(:not([enable-container])).ids-layout-grid-rows-lg-14,
  .ids-layout-grid:not([enable-container])[rows-lg="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="15"], :host(:not([enable-container])).ids-layout-grid-rows-lg-15,
  .ids-layout-grid:not([enable-container])[rows-lg="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="16"], :host(:not([enable-container])).ids-layout-grid-rows-lg-16,
  .ids-layout-grid:not([enable-container])[rows-lg="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="17"], :host(:not([enable-container])).ids-layout-grid-rows-lg-17,
  .ids-layout-grid:not([enable-container])[rows-lg="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="18"], :host(:not([enable-container])).ids-layout-grid-rows-lg-18,
  .ids-layout-grid:not([enable-container])[rows-lg="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="19"], :host(:not([enable-container])).ids-layout-grid-rows-lg-19,
  .ids-layout-grid:not([enable-container])[rows-lg="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="20"], :host(:not([enable-container])).ids-layout-grid-rows-lg-20,
  .ids-layout-grid:not([enable-container])[rows-lg="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="21"], :host(:not([enable-container])).ids-layout-grid-rows-lg-21,
  .ids-layout-grid:not([enable-container])[rows-lg="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="22"], :host(:not([enable-container])).ids-layout-grid-rows-lg-22,
  .ids-layout-grid:not([enable-container])[rows-lg="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="23"], :host(:not([enable-container])).ids-layout-grid-rows-lg-23,
  .ids-layout-grid:not([enable-container])[rows-lg="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="24"], :host(:not([enable-container])).ids-layout-grid-rows-lg-24,
  .ids-layout-grid:not([enable-container])[rows-lg="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="25"], :host(:not([enable-container])).ids-layout-grid-rows-lg-25,
  .ids-layout-grid:not([enable-container])[rows-lg="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="26"], :host(:not([enable-container])).ids-layout-grid-rows-lg-26,
  .ids-layout-grid:not([enable-container])[rows-lg="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="27"], :host(:not([enable-container])).ids-layout-grid-rows-lg-27,
  .ids-layout-grid:not([enable-container])[rows-lg="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="28"], :host(:not([enable-container])).ids-layout-grid-rows-lg-28,
  .ids-layout-grid:not([enable-container])[rows-lg="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="29"], :host(:not([enable-container])).ids-layout-grid-rows-lg-29,
  .ids-layout-grid:not([enable-container])[rows-lg="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="30"], :host(:not([enable-container])).ids-layout-grid-rows-lg-30,
  .ids-layout-grid:not([enable-container])[rows-lg="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="31"], :host(:not([enable-container])).ids-layout-grid-rows-lg-31,
  .ids-layout-grid:not([enable-container])[rows-lg="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="32"], :host(:not([enable-container])).ids-layout-grid-rows-lg-32,
  .ids-layout-grid:not([enable-container])[rows-lg="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="33"], :host(:not([enable-container])).ids-layout-grid-rows-lg-33,
  .ids-layout-grid:not([enable-container])[rows-lg="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="34"], :host(:not([enable-container])).ids-layout-grid-rows-lg-34,
  .ids-layout-grid:not([enable-container])[rows-lg="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="35"], :host(:not([enable-container])).ids-layout-grid-rows-lg-35,
  .ids-layout-grid:not([enable-container])[rows-lg="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="36"], :host(:not([enable-container])).ids-layout-grid-rows-lg-36,
  .ids-layout-grid:not([enable-container])[rows-lg="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="37"], :host(:not([enable-container])).ids-layout-grid-rows-lg-37,
  .ids-layout-grid:not([enable-container])[rows-lg="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="38"], :host(:not([enable-container])).ids-layout-grid-rows-lg-38,
  .ids-layout-grid:not([enable-container])[rows-lg="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="39"], :host(:not([enable-container])).ids-layout-grid-rows-lg-39,
  .ids-layout-grid:not([enable-container])[rows-lg="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="40"], :host(:not([enable-container])).ids-layout-grid-rows-lg-40,
  .ids-layout-grid:not([enable-container])[rows-lg="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="41"], :host(:not([enable-container])).ids-layout-grid-rows-lg-41,
  .ids-layout-grid:not([enable-container])[rows-lg="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="42"], :host(:not([enable-container])).ids-layout-grid-rows-lg-42,
  .ids-layout-grid:not([enable-container])[rows-lg="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="43"], :host(:not([enable-container])).ids-layout-grid-rows-lg-43,
  .ids-layout-grid:not([enable-container])[rows-lg="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="44"], :host(:not([enable-container])).ids-layout-grid-rows-lg-44,
  .ids-layout-grid:not([enable-container])[rows-lg="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="45"], :host(:not([enable-container])).ids-layout-grid-rows-lg-45,
  .ids-layout-grid:not([enable-container])[rows-lg="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="46"], :host(:not([enable-container])).ids-layout-grid-rows-lg-46,
  .ids-layout-grid:not([enable-container])[rows-lg="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="47"], :host(:not([enable-container])).ids-layout-grid-rows-lg-47,
  .ids-layout-grid:not([enable-container])[rows-lg="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="48"], :host(:not([enable-container])).ids-layout-grid-rows-lg-48,
  .ids-layout-grid:not([enable-container])[rows-lg="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="49"], :host(:not([enable-container])).ids-layout-grid-rows-lg-49,
  .ids-layout-grid:not([enable-container])[rows-lg="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="50"], :host(:not([enable-container])).ids-layout-grid-rows-lg-50,
  .ids-layout-grid:not([enable-container])[rows-lg="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=lg]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=lg]) {
    display: block;
  }
}
@media (min-width: 1280px) {
  :host(:not([enable-container])) > ::slotted([col-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xl-1,
  .ids-layout-grid:not([enable-container])[rows-xl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xl-2,
  .ids-layout-grid:not([enable-container])[rows-xl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xl-3,
  .ids-layout-grid:not([enable-container])[rows-xl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xl-4,
  .ids-layout-grid:not([enable-container])[rows-xl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xl-5,
  .ids-layout-grid:not([enable-container])[rows-xl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xl-6,
  .ids-layout-grid:not([enable-container])[rows-xl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xl-7,
  .ids-layout-grid:not([enable-container])[rows-xl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xl-8,
  .ids-layout-grid:not([enable-container])[rows-xl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xl-9,
  .ids-layout-grid:not([enable-container])[rows-xl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xl-10,
  .ids-layout-grid:not([enable-container])[rows-xl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xl-11,
  .ids-layout-grid:not([enable-container])[rows-xl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xl-12,
  .ids-layout-grid:not([enable-container])[rows-xl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xl-13,
  .ids-layout-grid:not([enable-container])[rows-xl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xl-14,
  .ids-layout-grid:not([enable-container])[rows-xl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xl-15,
  .ids-layout-grid:not([enable-container])[rows-xl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xl-16,
  .ids-layout-grid:not([enable-container])[rows-xl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xl-17,
  .ids-layout-grid:not([enable-container])[rows-xl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xl-18,
  .ids-layout-grid:not([enable-container])[rows-xl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xl-19,
  .ids-layout-grid:not([enable-container])[rows-xl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xl-20,
  .ids-layout-grid:not([enable-container])[rows-xl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xl-21,
  .ids-layout-grid:not([enable-container])[rows-xl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xl-22,
  .ids-layout-grid:not([enable-container])[rows-xl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xl-23,
  .ids-layout-grid:not([enable-container])[rows-xl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xl-24,
  .ids-layout-grid:not([enable-container])[rows-xl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xl-25,
  .ids-layout-grid:not([enable-container])[rows-xl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xl-26,
  .ids-layout-grid:not([enable-container])[rows-xl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xl-27,
  .ids-layout-grid:not([enable-container])[rows-xl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xl-28,
  .ids-layout-grid:not([enable-container])[rows-xl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xl-29,
  .ids-layout-grid:not([enable-container])[rows-xl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xl-30,
  .ids-layout-grid:not([enable-container])[rows-xl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xl-31,
  .ids-layout-grid:not([enable-container])[rows-xl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xl-32,
  .ids-layout-grid:not([enable-container])[rows-xl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xl-33,
  .ids-layout-grid:not([enable-container])[rows-xl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xl-34,
  .ids-layout-grid:not([enable-container])[rows-xl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xl-35,
  .ids-layout-grid:not([enable-container])[rows-xl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xl-36,
  .ids-layout-grid:not([enable-container])[rows-xl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xl-37,
  .ids-layout-grid:not([enable-container])[rows-xl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xl-38,
  .ids-layout-grid:not([enable-container])[rows-xl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xl-39,
  .ids-layout-grid:not([enable-container])[rows-xl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xl-40,
  .ids-layout-grid:not([enable-container])[rows-xl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xl-41,
  .ids-layout-grid:not([enable-container])[rows-xl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xl-42,
  .ids-layout-grid:not([enable-container])[rows-xl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xl-43,
  .ids-layout-grid:not([enable-container])[rows-xl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xl-44,
  .ids-layout-grid:not([enable-container])[rows-xl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xl-45,
  .ids-layout-grid:not([enable-container])[rows-xl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xl-46,
  .ids-layout-grid:not([enable-container])[rows-xl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xl-47,
  .ids-layout-grid:not([enable-container])[rows-xl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xl-48,
  .ids-layout-grid:not([enable-container])[rows-xl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xl-49,
  .ids-layout-grid:not([enable-container])[rows-xl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xl-50,
  .ids-layout-grid:not([enable-container])[rows-xl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xl]) {
    display: block;
  }
}
@media (min-width: 1440px) {
  :host(:not([enable-container])) > ::slotted([col-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xxl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid:not([enable-container])[rows-xxl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid:not([enable-container])[rows-xxl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid:not([enable-container])[rows-xxl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid:not([enable-container])[rows-xxl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid:not([enable-container])[rows-xxl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid:not([enable-container])[rows-xxl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid:not([enable-container])[rows-xxl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid:not([enable-container])[rows-xxl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid:not([enable-container])[rows-xxl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid:not([enable-container])[rows-xxl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid:not([enable-container])[rows-xxl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid:not([enable-container])[rows-xxl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid:not([enable-container])[rows-xxl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid:not([enable-container])[rows-xxl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid:not([enable-container])[rows-xxl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid:not([enable-container])[rows-xxl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid:not([enable-container])[rows-xxl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid:not([enable-container])[rows-xxl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid:not([enable-container])[rows-xxl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid:not([enable-container])[rows-xxl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid:not([enable-container])[rows-xxl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid:not([enable-container])[rows-xxl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid:not([enable-container])[rows-xxl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid:not([enable-container])[rows-xxl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid:not([enable-container])[rows-xxl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid:not([enable-container])[rows-xxl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid:not([enable-container])[rows-xxl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid:not([enable-container])[rows-xxl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid:not([enable-container])[rows-xxl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid:not([enable-container])[rows-xxl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid:not([enable-container])[rows-xxl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid:not([enable-container])[rows-xxl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid:not([enable-container])[rows-xxl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid:not([enable-container])[rows-xxl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid:not([enable-container])[rows-xxl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid:not([enable-container])[rows-xxl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid:not([enable-container])[rows-xxl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid:not([enable-container])[rows-xxl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid:not([enable-container])[rows-xxl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid:not([enable-container])[rows-xxl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid:not([enable-container])[rows-xxl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid:not([enable-container])[rows-xxl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid:not([enable-container])[rows-xxl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid:not([enable-container])[rows-xxl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid:not([enable-container])[rows-xxl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid:not([enable-container])[rows-xxl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid:not([enable-container])[rows-xxl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid:not([enable-container])[rows-xxl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid:not([enable-container])[rows-xxl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid:not([enable-container])[rows-xxl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xxl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Use container queries if enabled */
:host([enable-container]),
.ids-layout-grid[enable-container] {
  container-type: inline-size;
}
@container (min-width: 360px) {
  :host([enable-container]) > ::slotted([col-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xs="1"], :host([enable-container]).ids-layout-grid-rows-xs-1,
  .ids-layout-grid[enable-container][rows-xs="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="2"], :host([enable-container]).ids-layout-grid-rows-xs-2,
  .ids-layout-grid[enable-container][rows-xs="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="3"], :host([enable-container]).ids-layout-grid-rows-xs-3,
  .ids-layout-grid[enable-container][rows-xs="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="4"], :host([enable-container]).ids-layout-grid-rows-xs-4,
  .ids-layout-grid[enable-container][rows-xs="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="5"], :host([enable-container]).ids-layout-grid-rows-xs-5,
  .ids-layout-grid[enable-container][rows-xs="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="6"], :host([enable-container]).ids-layout-grid-rows-xs-6,
  .ids-layout-grid[enable-container][rows-xs="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="7"], :host([enable-container]).ids-layout-grid-rows-xs-7,
  .ids-layout-grid[enable-container][rows-xs="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="8"], :host([enable-container]).ids-layout-grid-rows-xs-8,
  .ids-layout-grid[enable-container][rows-xs="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="9"], :host([enable-container]).ids-layout-grid-rows-xs-9,
  .ids-layout-grid[enable-container][rows-xs="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="10"], :host([enable-container]).ids-layout-grid-rows-xs-10,
  .ids-layout-grid[enable-container][rows-xs="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="11"], :host([enable-container]).ids-layout-grid-rows-xs-11,
  .ids-layout-grid[enable-container][rows-xs="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="12"], :host([enable-container]).ids-layout-grid-rows-xs-12,
  .ids-layout-grid[enable-container][rows-xs="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="13"], :host([enable-container]).ids-layout-grid-rows-xs-13,
  .ids-layout-grid[enable-container][rows-xs="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="14"], :host([enable-container]).ids-layout-grid-rows-xs-14,
  .ids-layout-grid[enable-container][rows-xs="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="15"], :host([enable-container]).ids-layout-grid-rows-xs-15,
  .ids-layout-grid[enable-container][rows-xs="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="16"], :host([enable-container]).ids-layout-grid-rows-xs-16,
  .ids-layout-grid[enable-container][rows-xs="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="17"], :host([enable-container]).ids-layout-grid-rows-xs-17,
  .ids-layout-grid[enable-container][rows-xs="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="18"], :host([enable-container]).ids-layout-grid-rows-xs-18,
  .ids-layout-grid[enable-container][rows-xs="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="19"], :host([enable-container]).ids-layout-grid-rows-xs-19,
  .ids-layout-grid[enable-container][rows-xs="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="20"], :host([enable-container]).ids-layout-grid-rows-xs-20,
  .ids-layout-grid[enable-container][rows-xs="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="21"], :host([enable-container]).ids-layout-grid-rows-xs-21,
  .ids-layout-grid[enable-container][rows-xs="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="22"], :host([enable-container]).ids-layout-grid-rows-xs-22,
  .ids-layout-grid[enable-container][rows-xs="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="23"], :host([enable-container]).ids-layout-grid-rows-xs-23,
  .ids-layout-grid[enable-container][rows-xs="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="24"], :host([enable-container]).ids-layout-grid-rows-xs-24,
  .ids-layout-grid[enable-container][rows-xs="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="25"], :host([enable-container]).ids-layout-grid-rows-xs-25,
  .ids-layout-grid[enable-container][rows-xs="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="26"], :host([enable-container]).ids-layout-grid-rows-xs-26,
  .ids-layout-grid[enable-container][rows-xs="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="27"], :host([enable-container]).ids-layout-grid-rows-xs-27,
  .ids-layout-grid[enable-container][rows-xs="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="28"], :host([enable-container]).ids-layout-grid-rows-xs-28,
  .ids-layout-grid[enable-container][rows-xs="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="29"], :host([enable-container]).ids-layout-grid-rows-xs-29,
  .ids-layout-grid[enable-container][rows-xs="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="30"], :host([enable-container]).ids-layout-grid-rows-xs-30,
  .ids-layout-grid[enable-container][rows-xs="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="31"], :host([enable-container]).ids-layout-grid-rows-xs-31,
  .ids-layout-grid[enable-container][rows-xs="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="32"], :host([enable-container]).ids-layout-grid-rows-xs-32,
  .ids-layout-grid[enable-container][rows-xs="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="33"], :host([enable-container]).ids-layout-grid-rows-xs-33,
  .ids-layout-grid[enable-container][rows-xs="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="34"], :host([enable-container]).ids-layout-grid-rows-xs-34,
  .ids-layout-grid[enable-container][rows-xs="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="35"], :host([enable-container]).ids-layout-grid-rows-xs-35,
  .ids-layout-grid[enable-container][rows-xs="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="36"], :host([enable-container]).ids-layout-grid-rows-xs-36,
  .ids-layout-grid[enable-container][rows-xs="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="37"], :host([enable-container]).ids-layout-grid-rows-xs-37,
  .ids-layout-grid[enable-container][rows-xs="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="38"], :host([enable-container]).ids-layout-grid-rows-xs-38,
  .ids-layout-grid[enable-container][rows-xs="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="39"], :host([enable-container]).ids-layout-grid-rows-xs-39,
  .ids-layout-grid[enable-container][rows-xs="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="40"], :host([enable-container]).ids-layout-grid-rows-xs-40,
  .ids-layout-grid[enable-container][rows-xs="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="41"], :host([enable-container]).ids-layout-grid-rows-xs-41,
  .ids-layout-grid[enable-container][rows-xs="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="42"], :host([enable-container]).ids-layout-grid-rows-xs-42,
  .ids-layout-grid[enable-container][rows-xs="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="43"], :host([enable-container]).ids-layout-grid-rows-xs-43,
  .ids-layout-grid[enable-container][rows-xs="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="44"], :host([enable-container]).ids-layout-grid-rows-xs-44,
  .ids-layout-grid[enable-container][rows-xs="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="45"], :host([enable-container]).ids-layout-grid-rows-xs-45,
  .ids-layout-grid[enable-container][rows-xs="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="46"], :host([enable-container]).ids-layout-grid-rows-xs-46,
  .ids-layout-grid[enable-container][rows-xs="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="47"], :host([enable-container]).ids-layout-grid-rows-xs-47,
  .ids-layout-grid[enable-container][rows-xs="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="48"], :host([enable-container]).ids-layout-grid-rows-xs-48,
  .ids-layout-grid[enable-container][rows-xs="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="49"], :host([enable-container]).ids-layout-grid-rows-xs-49,
  .ids-layout-grid[enable-container][rows-xs="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="50"], :host([enable-container]).ids-layout-grid-rows-xs-50,
  .ids-layout-grid[enable-container][rows-xs="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xs]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xs]) {
    display: block;
  }
}
@container (min-width: 600px) {
  :host([enable-container]) > ::slotted([col-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-sm="1"], :host([enable-container]).ids-layout-grid-rows-sm-1,
  .ids-layout-grid[enable-container][rows-sm="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="2"], :host([enable-container]).ids-layout-grid-rows-sm-2,
  .ids-layout-grid[enable-container][rows-sm="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="3"], :host([enable-container]).ids-layout-grid-rows-sm-3,
  .ids-layout-grid[enable-container][rows-sm="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="4"], :host([enable-container]).ids-layout-grid-rows-sm-4,
  .ids-layout-grid[enable-container][rows-sm="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="5"], :host([enable-container]).ids-layout-grid-rows-sm-5,
  .ids-layout-grid[enable-container][rows-sm="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="6"], :host([enable-container]).ids-layout-grid-rows-sm-6,
  .ids-layout-grid[enable-container][rows-sm="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="7"], :host([enable-container]).ids-layout-grid-rows-sm-7,
  .ids-layout-grid[enable-container][rows-sm="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="8"], :host([enable-container]).ids-layout-grid-rows-sm-8,
  .ids-layout-grid[enable-container][rows-sm="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="9"], :host([enable-container]).ids-layout-grid-rows-sm-9,
  .ids-layout-grid[enable-container][rows-sm="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="10"], :host([enable-container]).ids-layout-grid-rows-sm-10,
  .ids-layout-grid[enable-container][rows-sm="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="11"], :host([enable-container]).ids-layout-grid-rows-sm-11,
  .ids-layout-grid[enable-container][rows-sm="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="12"], :host([enable-container]).ids-layout-grid-rows-sm-12,
  .ids-layout-grid[enable-container][rows-sm="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="13"], :host([enable-container]).ids-layout-grid-rows-sm-13,
  .ids-layout-grid[enable-container][rows-sm="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="14"], :host([enable-container]).ids-layout-grid-rows-sm-14,
  .ids-layout-grid[enable-container][rows-sm="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="15"], :host([enable-container]).ids-layout-grid-rows-sm-15,
  .ids-layout-grid[enable-container][rows-sm="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="16"], :host([enable-container]).ids-layout-grid-rows-sm-16,
  .ids-layout-grid[enable-container][rows-sm="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="17"], :host([enable-container]).ids-layout-grid-rows-sm-17,
  .ids-layout-grid[enable-container][rows-sm="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="18"], :host([enable-container]).ids-layout-grid-rows-sm-18,
  .ids-layout-grid[enable-container][rows-sm="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="19"], :host([enable-container]).ids-layout-grid-rows-sm-19,
  .ids-layout-grid[enable-container][rows-sm="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="20"], :host([enable-container]).ids-layout-grid-rows-sm-20,
  .ids-layout-grid[enable-container][rows-sm="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="21"], :host([enable-container]).ids-layout-grid-rows-sm-21,
  .ids-layout-grid[enable-container][rows-sm="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="22"], :host([enable-container]).ids-layout-grid-rows-sm-22,
  .ids-layout-grid[enable-container][rows-sm="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="23"], :host([enable-container]).ids-layout-grid-rows-sm-23,
  .ids-layout-grid[enable-container][rows-sm="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="24"], :host([enable-container]).ids-layout-grid-rows-sm-24,
  .ids-layout-grid[enable-container][rows-sm="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="25"], :host([enable-container]).ids-layout-grid-rows-sm-25,
  .ids-layout-grid[enable-container][rows-sm="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="26"], :host([enable-container]).ids-layout-grid-rows-sm-26,
  .ids-layout-grid[enable-container][rows-sm="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="27"], :host([enable-container]).ids-layout-grid-rows-sm-27,
  .ids-layout-grid[enable-container][rows-sm="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="28"], :host([enable-container]).ids-layout-grid-rows-sm-28,
  .ids-layout-grid[enable-container][rows-sm="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="29"], :host([enable-container]).ids-layout-grid-rows-sm-29,
  .ids-layout-grid[enable-container][rows-sm="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="30"], :host([enable-container]).ids-layout-grid-rows-sm-30,
  .ids-layout-grid[enable-container][rows-sm="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="31"], :host([enable-container]).ids-layout-grid-rows-sm-31,
  .ids-layout-grid[enable-container][rows-sm="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="32"], :host([enable-container]).ids-layout-grid-rows-sm-32,
  .ids-layout-grid[enable-container][rows-sm="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="33"], :host([enable-container]).ids-layout-grid-rows-sm-33,
  .ids-layout-grid[enable-container][rows-sm="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="34"], :host([enable-container]).ids-layout-grid-rows-sm-34,
  .ids-layout-grid[enable-container][rows-sm="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="35"], :host([enable-container]).ids-layout-grid-rows-sm-35,
  .ids-layout-grid[enable-container][rows-sm="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="36"], :host([enable-container]).ids-layout-grid-rows-sm-36,
  .ids-layout-grid[enable-container][rows-sm="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="37"], :host([enable-container]).ids-layout-grid-rows-sm-37,
  .ids-layout-grid[enable-container][rows-sm="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="38"], :host([enable-container]).ids-layout-grid-rows-sm-38,
  .ids-layout-grid[enable-container][rows-sm="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="39"], :host([enable-container]).ids-layout-grid-rows-sm-39,
  .ids-layout-grid[enable-container][rows-sm="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="40"], :host([enable-container]).ids-layout-grid-rows-sm-40,
  .ids-layout-grid[enable-container][rows-sm="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="41"], :host([enable-container]).ids-layout-grid-rows-sm-41,
  .ids-layout-grid[enable-container][rows-sm="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="42"], :host([enable-container]).ids-layout-grid-rows-sm-42,
  .ids-layout-grid[enable-container][rows-sm="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="43"], :host([enable-container]).ids-layout-grid-rows-sm-43,
  .ids-layout-grid[enable-container][rows-sm="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="44"], :host([enable-container]).ids-layout-grid-rows-sm-44,
  .ids-layout-grid[enable-container][rows-sm="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="45"], :host([enable-container]).ids-layout-grid-rows-sm-45,
  .ids-layout-grid[enable-container][rows-sm="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="46"], :host([enable-container]).ids-layout-grid-rows-sm-46,
  .ids-layout-grid[enable-container][rows-sm="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="47"], :host([enable-container]).ids-layout-grid-rows-sm-47,
  .ids-layout-grid[enable-container][rows-sm="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="48"], :host([enable-container]).ids-layout-grid-rows-sm-48,
  .ids-layout-grid[enable-container][rows-sm="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="49"], :host([enable-container]).ids-layout-grid-rows-sm-49,
  .ids-layout-grid[enable-container][rows-sm="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="50"], :host([enable-container]).ids-layout-grid-rows-sm-50,
  .ids-layout-grid[enable-container][rows-sm="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=sm]),
  .ids-layout-grid[enable-container] > ::slotted([hide=sm]) {
    display: block;
  }
}
@container (min-width: 840px) {
  :host([enable-container]) > ::slotted([col-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-md="1"], :host([enable-container]).ids-layout-grid-rows-md-1,
  .ids-layout-grid[enable-container][rows-md="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="2"], :host([enable-container]).ids-layout-grid-rows-md-2,
  .ids-layout-grid[enable-container][rows-md="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid[enable-container] > ::slotted([order-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="3"], :host([enable-container]).ids-layout-grid-rows-md-3,
  .ids-layout-grid[enable-container][rows-md="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid[enable-container] > ::slotted([order-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="4"], :host([enable-container]).ids-layout-grid-rows-md-4,
  .ids-layout-grid[enable-container][rows-md="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid[enable-container] > ::slotted([order-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="5"], :host([enable-container]).ids-layout-grid-rows-md-5,
  .ids-layout-grid[enable-container][rows-md="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid[enable-container] > ::slotted([order-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="6"], :host([enable-container]).ids-layout-grid-rows-md-6,
  .ids-layout-grid[enable-container][rows-md="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid[enable-container] > ::slotted([order-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="7"], :host([enable-container]).ids-layout-grid-rows-md-7,
  .ids-layout-grid[enable-container][rows-md="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid[enable-container] > ::slotted([order-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="8"], :host([enable-container]).ids-layout-grid-rows-md-8,
  .ids-layout-grid[enable-container][rows-md="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid[enable-container] > ::slotted([order-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="9"], :host([enable-container]).ids-layout-grid-rows-md-9,
  .ids-layout-grid[enable-container][rows-md="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid[enable-container] > ::slotted([order-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="10"], :host([enable-container]).ids-layout-grid-rows-md-10,
  .ids-layout-grid[enable-container][rows-md="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid[enable-container] > ::slotted([order-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="11"], :host([enable-container]).ids-layout-grid-rows-md-11,
  .ids-layout-grid[enable-container][rows-md="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid[enable-container] > ::slotted([order-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="12"], :host([enable-container]).ids-layout-grid-rows-md-12,
  .ids-layout-grid[enable-container][rows-md="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid[enable-container] > ::slotted([order-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="13"], :host([enable-container]).ids-layout-grid-rows-md-13,
  .ids-layout-grid[enable-container][rows-md="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid[enable-container] > ::slotted([order-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="14"], :host([enable-container]).ids-layout-grid-rows-md-14,
  .ids-layout-grid[enable-container][rows-md="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid[enable-container] > ::slotted([order-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="15"], :host([enable-container]).ids-layout-grid-rows-md-15,
  .ids-layout-grid[enable-container][rows-md="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid[enable-container] > ::slotted([order-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="16"], :host([enable-container]).ids-layout-grid-rows-md-16,
  .ids-layout-grid[enable-container][rows-md="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid[enable-container] > ::slotted([order-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="17"], :host([enable-container]).ids-layout-grid-rows-md-17,
  .ids-layout-grid[enable-container][rows-md="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid[enable-container] > ::slotted([order-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="18"], :host([enable-container]).ids-layout-grid-rows-md-18,
  .ids-layout-grid[enable-container][rows-md="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid[enable-container] > ::slotted([order-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="19"], :host([enable-container]).ids-layout-grid-rows-md-19,
  .ids-layout-grid[enable-container][rows-md="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid[enable-container] > ::slotted([order-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="20"], :host([enable-container]).ids-layout-grid-rows-md-20,
  .ids-layout-grid[enable-container][rows-md="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid[enable-container] > ::slotted([order-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="21"], :host([enable-container]).ids-layout-grid-rows-md-21,
  .ids-layout-grid[enable-container][rows-md="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid[enable-container] > ::slotted([order-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="22"], :host([enable-container]).ids-layout-grid-rows-md-22,
  .ids-layout-grid[enable-container][rows-md="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid[enable-container] > ::slotted([order-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="23"], :host([enable-container]).ids-layout-grid-rows-md-23,
  .ids-layout-grid[enable-container][rows-md="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid[enable-container] > ::slotted([order-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="24"], :host([enable-container]).ids-layout-grid-rows-md-24,
  .ids-layout-grid[enable-container][rows-md="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid[enable-container] > ::slotted([order-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="25"], :host([enable-container]).ids-layout-grid-rows-md-25,
  .ids-layout-grid[enable-container][rows-md="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid[enable-container] > ::slotted([order-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="26"], :host([enable-container]).ids-layout-grid-rows-md-26,
  .ids-layout-grid[enable-container][rows-md="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid[enable-container] > ::slotted([order-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="27"], :host([enable-container]).ids-layout-grid-rows-md-27,
  .ids-layout-grid[enable-container][rows-md="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid[enable-container] > ::slotted([order-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="28"], :host([enable-container]).ids-layout-grid-rows-md-28,
  .ids-layout-grid[enable-container][rows-md="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid[enable-container] > ::slotted([order-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="29"], :host([enable-container]).ids-layout-grid-rows-md-29,
  .ids-layout-grid[enable-container][rows-md="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid[enable-container] > ::slotted([order-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="30"], :host([enable-container]).ids-layout-grid-rows-md-30,
  .ids-layout-grid[enable-container][rows-md="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid[enable-container] > ::slotted([order-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="31"], :host([enable-container]).ids-layout-grid-rows-md-31,
  .ids-layout-grid[enable-container][rows-md="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid[enable-container] > ::slotted([order-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="32"], :host([enable-container]).ids-layout-grid-rows-md-32,
  .ids-layout-grid[enable-container][rows-md="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid[enable-container] > ::slotted([order-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="33"], :host([enable-container]).ids-layout-grid-rows-md-33,
  .ids-layout-grid[enable-container][rows-md="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid[enable-container] > ::slotted([order-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="34"], :host([enable-container]).ids-layout-grid-rows-md-34,
  .ids-layout-grid[enable-container][rows-md="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid[enable-container] > ::slotted([order-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="35"], :host([enable-container]).ids-layout-grid-rows-md-35,
  .ids-layout-grid[enable-container][rows-md="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid[enable-container] > ::slotted([order-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="36"], :host([enable-container]).ids-layout-grid-rows-md-36,
  .ids-layout-grid[enable-container][rows-md="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid[enable-container] > ::slotted([order-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="37"], :host([enable-container]).ids-layout-grid-rows-md-37,
  .ids-layout-grid[enable-container][rows-md="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid[enable-container] > ::slotted([order-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="38"], :host([enable-container]).ids-layout-grid-rows-md-38,
  .ids-layout-grid[enable-container][rows-md="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid[enable-container] > ::slotted([order-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="39"], :host([enable-container]).ids-layout-grid-rows-md-39,
  .ids-layout-grid[enable-container][rows-md="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid[enable-container] > ::slotted([order-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="40"], :host([enable-container]).ids-layout-grid-rows-md-40,
  .ids-layout-grid[enable-container][rows-md="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid[enable-container] > ::slotted([order-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="41"], :host([enable-container]).ids-layout-grid-rows-md-41,
  .ids-layout-grid[enable-container][rows-md="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid[enable-container] > ::slotted([order-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="42"], :host([enable-container]).ids-layout-grid-rows-md-42,
  .ids-layout-grid[enable-container][rows-md="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid[enable-container] > ::slotted([order-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="43"], :host([enable-container]).ids-layout-grid-rows-md-43,
  .ids-layout-grid[enable-container][rows-md="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid[enable-container] > ::slotted([order-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="44"], :host([enable-container]).ids-layout-grid-rows-md-44,
  .ids-layout-grid[enable-container][rows-md="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid[enable-container] > ::slotted([order-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="45"], :host([enable-container]).ids-layout-grid-rows-md-45,
  .ids-layout-grid[enable-container][rows-md="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid[enable-container] > ::slotted([order-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="46"], :host([enable-container]).ids-layout-grid-rows-md-46,
  .ids-layout-grid[enable-container][rows-md="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid[enable-container] > ::slotted([order-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="47"], :host([enable-container]).ids-layout-grid-rows-md-47,
  .ids-layout-grid[enable-container][rows-md="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid[enable-container] > ::slotted([order-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="48"], :host([enable-container]).ids-layout-grid-rows-md-48,
  .ids-layout-grid[enable-container][rows-md="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid[enable-container] > ::slotted([order-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="49"], :host([enable-container]).ids-layout-grid-rows-md-49,
  .ids-layout-grid[enable-container][rows-md="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid[enable-container] > ::slotted([order-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="50"], :host([enable-container]).ids-layout-grid-rows-md-50,
  .ids-layout-grid[enable-container][rows-md="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid[enable-container] > ::slotted([order-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=md]),
  .ids-layout-grid[enable-container] > ::slotted([hide=md]) {
    display: block;
  }
}
@container (min-width: 1024px) {
  :host([enable-container]) > ::slotted([col-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-lg="1"], :host([enable-container]).ids-layout-grid-rows-lg-1,
  .ids-layout-grid[enable-container][rows-lg="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="2"], :host([enable-container]).ids-layout-grid-rows-lg-2,
  .ids-layout-grid[enable-container][rows-lg="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="3"], :host([enable-container]).ids-layout-grid-rows-lg-3,
  .ids-layout-grid[enable-container][rows-lg="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="4"], :host([enable-container]).ids-layout-grid-rows-lg-4,
  .ids-layout-grid[enable-container][rows-lg="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="5"], :host([enable-container]).ids-layout-grid-rows-lg-5,
  .ids-layout-grid[enable-container][rows-lg="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="6"], :host([enable-container]).ids-layout-grid-rows-lg-6,
  .ids-layout-grid[enable-container][rows-lg="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="7"], :host([enable-container]).ids-layout-grid-rows-lg-7,
  .ids-layout-grid[enable-container][rows-lg="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="8"], :host([enable-container]).ids-layout-grid-rows-lg-8,
  .ids-layout-grid[enable-container][rows-lg="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="9"], :host([enable-container]).ids-layout-grid-rows-lg-9,
  .ids-layout-grid[enable-container][rows-lg="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="10"], :host([enable-container]).ids-layout-grid-rows-lg-10,
  .ids-layout-grid[enable-container][rows-lg="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="11"], :host([enable-container]).ids-layout-grid-rows-lg-11,
  .ids-layout-grid[enable-container][rows-lg="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="12"], :host([enable-container]).ids-layout-grid-rows-lg-12,
  .ids-layout-grid[enable-container][rows-lg="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="13"], :host([enable-container]).ids-layout-grid-rows-lg-13,
  .ids-layout-grid[enable-container][rows-lg="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="14"], :host([enable-container]).ids-layout-grid-rows-lg-14,
  .ids-layout-grid[enable-container][rows-lg="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="15"], :host([enable-container]).ids-layout-grid-rows-lg-15,
  .ids-layout-grid[enable-container][rows-lg="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="16"], :host([enable-container]).ids-layout-grid-rows-lg-16,
  .ids-layout-grid[enable-container][rows-lg="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="17"], :host([enable-container]).ids-layout-grid-rows-lg-17,
  .ids-layout-grid[enable-container][rows-lg="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="18"], :host([enable-container]).ids-layout-grid-rows-lg-18,
  .ids-layout-grid[enable-container][rows-lg="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="19"], :host([enable-container]).ids-layout-grid-rows-lg-19,
  .ids-layout-grid[enable-container][rows-lg="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="20"], :host([enable-container]).ids-layout-grid-rows-lg-20,
  .ids-layout-grid[enable-container][rows-lg="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="21"], :host([enable-container]).ids-layout-grid-rows-lg-21,
  .ids-layout-grid[enable-container][rows-lg="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="22"], :host([enable-container]).ids-layout-grid-rows-lg-22,
  .ids-layout-grid[enable-container][rows-lg="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="23"], :host([enable-container]).ids-layout-grid-rows-lg-23,
  .ids-layout-grid[enable-container][rows-lg="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="24"], :host([enable-container]).ids-layout-grid-rows-lg-24,
  .ids-layout-grid[enable-container][rows-lg="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="25"], :host([enable-container]).ids-layout-grid-rows-lg-25,
  .ids-layout-grid[enable-container][rows-lg="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="26"], :host([enable-container]).ids-layout-grid-rows-lg-26,
  .ids-layout-grid[enable-container][rows-lg="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="27"], :host([enable-container]).ids-layout-grid-rows-lg-27,
  .ids-layout-grid[enable-container][rows-lg="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="28"], :host([enable-container]).ids-layout-grid-rows-lg-28,
  .ids-layout-grid[enable-container][rows-lg="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="29"], :host([enable-container]).ids-layout-grid-rows-lg-29,
  .ids-layout-grid[enable-container][rows-lg="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="30"], :host([enable-container]).ids-layout-grid-rows-lg-30,
  .ids-layout-grid[enable-container][rows-lg="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="31"], :host([enable-container]).ids-layout-grid-rows-lg-31,
  .ids-layout-grid[enable-container][rows-lg="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="32"], :host([enable-container]).ids-layout-grid-rows-lg-32,
  .ids-layout-grid[enable-container][rows-lg="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="33"], :host([enable-container]).ids-layout-grid-rows-lg-33,
  .ids-layout-grid[enable-container][rows-lg="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="34"], :host([enable-container]).ids-layout-grid-rows-lg-34,
  .ids-layout-grid[enable-container][rows-lg="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="35"], :host([enable-container]).ids-layout-grid-rows-lg-35,
  .ids-layout-grid[enable-container][rows-lg="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="36"], :host([enable-container]).ids-layout-grid-rows-lg-36,
  .ids-layout-grid[enable-container][rows-lg="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="37"], :host([enable-container]).ids-layout-grid-rows-lg-37,
  .ids-layout-grid[enable-container][rows-lg="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="38"], :host([enable-container]).ids-layout-grid-rows-lg-38,
  .ids-layout-grid[enable-container][rows-lg="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="39"], :host([enable-container]).ids-layout-grid-rows-lg-39,
  .ids-layout-grid[enable-container][rows-lg="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="40"], :host([enable-container]).ids-layout-grid-rows-lg-40,
  .ids-layout-grid[enable-container][rows-lg="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="41"], :host([enable-container]).ids-layout-grid-rows-lg-41,
  .ids-layout-grid[enable-container][rows-lg="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="42"], :host([enable-container]).ids-layout-grid-rows-lg-42,
  .ids-layout-grid[enable-container][rows-lg="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="43"], :host([enable-container]).ids-layout-grid-rows-lg-43,
  .ids-layout-grid[enable-container][rows-lg="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="44"], :host([enable-container]).ids-layout-grid-rows-lg-44,
  .ids-layout-grid[enable-container][rows-lg="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="45"], :host([enable-container]).ids-layout-grid-rows-lg-45,
  .ids-layout-grid[enable-container][rows-lg="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="46"], :host([enable-container]).ids-layout-grid-rows-lg-46,
  .ids-layout-grid[enable-container][rows-lg="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="47"], :host([enable-container]).ids-layout-grid-rows-lg-47,
  .ids-layout-grid[enable-container][rows-lg="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="48"], :host([enable-container]).ids-layout-grid-rows-lg-48,
  .ids-layout-grid[enable-container][rows-lg="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="49"], :host([enable-container]).ids-layout-grid-rows-lg-49,
  .ids-layout-grid[enable-container][rows-lg="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="50"], :host([enable-container]).ids-layout-grid-rows-lg-50,
  .ids-layout-grid[enable-container][rows-lg="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=lg]),
  .ids-layout-grid[enable-container] > ::slotted([hide=lg]) {
    display: block;
  }
}
@container (min-width: 1280px) {
  :host([enable-container]) > ::slotted([col-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xl="1"], :host([enable-container]).ids-layout-grid-rows-xl-1,
  .ids-layout-grid[enable-container][rows-xl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="2"], :host([enable-container]).ids-layout-grid-rows-xl-2,
  .ids-layout-grid[enable-container][rows-xl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="3"], :host([enable-container]).ids-layout-grid-rows-xl-3,
  .ids-layout-grid[enable-container][rows-xl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="4"], :host([enable-container]).ids-layout-grid-rows-xl-4,
  .ids-layout-grid[enable-container][rows-xl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="5"], :host([enable-container]).ids-layout-grid-rows-xl-5,
  .ids-layout-grid[enable-container][rows-xl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="6"], :host([enable-container]).ids-layout-grid-rows-xl-6,
  .ids-layout-grid[enable-container][rows-xl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="7"], :host([enable-container]).ids-layout-grid-rows-xl-7,
  .ids-layout-grid[enable-container][rows-xl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="8"], :host([enable-container]).ids-layout-grid-rows-xl-8,
  .ids-layout-grid[enable-container][rows-xl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="9"], :host([enable-container]).ids-layout-grid-rows-xl-9,
  .ids-layout-grid[enable-container][rows-xl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="10"], :host([enable-container]).ids-layout-grid-rows-xl-10,
  .ids-layout-grid[enable-container][rows-xl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="11"], :host([enable-container]).ids-layout-grid-rows-xl-11,
  .ids-layout-grid[enable-container][rows-xl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="12"], :host([enable-container]).ids-layout-grid-rows-xl-12,
  .ids-layout-grid[enable-container][rows-xl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="13"], :host([enable-container]).ids-layout-grid-rows-xl-13,
  .ids-layout-grid[enable-container][rows-xl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="14"], :host([enable-container]).ids-layout-grid-rows-xl-14,
  .ids-layout-grid[enable-container][rows-xl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="15"], :host([enable-container]).ids-layout-grid-rows-xl-15,
  .ids-layout-grid[enable-container][rows-xl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="16"], :host([enable-container]).ids-layout-grid-rows-xl-16,
  .ids-layout-grid[enable-container][rows-xl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="17"], :host([enable-container]).ids-layout-grid-rows-xl-17,
  .ids-layout-grid[enable-container][rows-xl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="18"], :host([enable-container]).ids-layout-grid-rows-xl-18,
  .ids-layout-grid[enable-container][rows-xl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="19"], :host([enable-container]).ids-layout-grid-rows-xl-19,
  .ids-layout-grid[enable-container][rows-xl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="20"], :host([enable-container]).ids-layout-grid-rows-xl-20,
  .ids-layout-grid[enable-container][rows-xl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="21"], :host([enable-container]).ids-layout-grid-rows-xl-21,
  .ids-layout-grid[enable-container][rows-xl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="22"], :host([enable-container]).ids-layout-grid-rows-xl-22,
  .ids-layout-grid[enable-container][rows-xl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="23"], :host([enable-container]).ids-layout-grid-rows-xl-23,
  .ids-layout-grid[enable-container][rows-xl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="24"], :host([enable-container]).ids-layout-grid-rows-xl-24,
  .ids-layout-grid[enable-container][rows-xl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="25"], :host([enable-container]).ids-layout-grid-rows-xl-25,
  .ids-layout-grid[enable-container][rows-xl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="26"], :host([enable-container]).ids-layout-grid-rows-xl-26,
  .ids-layout-grid[enable-container][rows-xl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="27"], :host([enable-container]).ids-layout-grid-rows-xl-27,
  .ids-layout-grid[enable-container][rows-xl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="28"], :host([enable-container]).ids-layout-grid-rows-xl-28,
  .ids-layout-grid[enable-container][rows-xl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="29"], :host([enable-container]).ids-layout-grid-rows-xl-29,
  .ids-layout-grid[enable-container][rows-xl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="30"], :host([enable-container]).ids-layout-grid-rows-xl-30,
  .ids-layout-grid[enable-container][rows-xl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="31"], :host([enable-container]).ids-layout-grid-rows-xl-31,
  .ids-layout-grid[enable-container][rows-xl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="32"], :host([enable-container]).ids-layout-grid-rows-xl-32,
  .ids-layout-grid[enable-container][rows-xl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="33"], :host([enable-container]).ids-layout-grid-rows-xl-33,
  .ids-layout-grid[enable-container][rows-xl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="34"], :host([enable-container]).ids-layout-grid-rows-xl-34,
  .ids-layout-grid[enable-container][rows-xl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="35"], :host([enable-container]).ids-layout-grid-rows-xl-35,
  .ids-layout-grid[enable-container][rows-xl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="36"], :host([enable-container]).ids-layout-grid-rows-xl-36,
  .ids-layout-grid[enable-container][rows-xl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="37"], :host([enable-container]).ids-layout-grid-rows-xl-37,
  .ids-layout-grid[enable-container][rows-xl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="38"], :host([enable-container]).ids-layout-grid-rows-xl-38,
  .ids-layout-grid[enable-container][rows-xl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="39"], :host([enable-container]).ids-layout-grid-rows-xl-39,
  .ids-layout-grid[enable-container][rows-xl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="40"], :host([enable-container]).ids-layout-grid-rows-xl-40,
  .ids-layout-grid[enable-container][rows-xl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="41"], :host([enable-container]).ids-layout-grid-rows-xl-41,
  .ids-layout-grid[enable-container][rows-xl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="42"], :host([enable-container]).ids-layout-grid-rows-xl-42,
  .ids-layout-grid[enable-container][rows-xl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="43"], :host([enable-container]).ids-layout-grid-rows-xl-43,
  .ids-layout-grid[enable-container][rows-xl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="44"], :host([enable-container]).ids-layout-grid-rows-xl-44,
  .ids-layout-grid[enable-container][rows-xl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="45"], :host([enable-container]).ids-layout-grid-rows-xl-45,
  .ids-layout-grid[enable-container][rows-xl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="46"], :host([enable-container]).ids-layout-grid-rows-xl-46,
  .ids-layout-grid[enable-container][rows-xl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="47"], :host([enable-container]).ids-layout-grid-rows-xl-47,
  .ids-layout-grid[enable-container][rows-xl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="48"], :host([enable-container]).ids-layout-grid-rows-xl-48,
  .ids-layout-grid[enable-container][rows-xl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="49"], :host([enable-container]).ids-layout-grid-rows-xl-49,
  .ids-layout-grid[enable-container][rows-xl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="50"], :host([enable-container]).ids-layout-grid-rows-xl-50,
  .ids-layout-grid[enable-container][rows-xl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xl]) {
    display: block;
  }
}
@container (min-width: 1440px) {
  :host([enable-container]) > ::slotted([col-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xxl="1"], :host([enable-container]).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid[enable-container][rows-xxl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="2"], :host([enable-container]).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid[enable-container][rows-xxl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="3"], :host([enable-container]).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid[enable-container][rows-xxl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="4"], :host([enable-container]).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid[enable-container][rows-xxl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="5"], :host([enable-container]).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid[enable-container][rows-xxl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="6"], :host([enable-container]).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid[enable-container][rows-xxl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="7"], :host([enable-container]).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid[enable-container][rows-xxl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="8"], :host([enable-container]).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid[enable-container][rows-xxl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="9"], :host([enable-container]).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid[enable-container][rows-xxl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="10"], :host([enable-container]).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid[enable-container][rows-xxl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="11"], :host([enable-container]).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid[enable-container][rows-xxl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="12"], :host([enable-container]).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid[enable-container][rows-xxl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="13"], :host([enable-container]).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid[enable-container][rows-xxl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="14"], :host([enable-container]).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid[enable-container][rows-xxl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="15"], :host([enable-container]).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid[enable-container][rows-xxl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="16"], :host([enable-container]).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid[enable-container][rows-xxl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="17"], :host([enable-container]).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid[enable-container][rows-xxl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="18"], :host([enable-container]).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid[enable-container][rows-xxl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="19"], :host([enable-container]).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid[enable-container][rows-xxl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="20"], :host([enable-container]).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid[enable-container][rows-xxl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="21"], :host([enable-container]).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid[enable-container][rows-xxl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="22"], :host([enable-container]).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid[enable-container][rows-xxl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="23"], :host([enable-container]).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid[enable-container][rows-xxl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="24"], :host([enable-container]).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid[enable-container][rows-xxl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="25"], :host([enable-container]).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid[enable-container][rows-xxl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="26"], :host([enable-container]).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid[enable-container][rows-xxl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="27"], :host([enable-container]).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid[enable-container][rows-xxl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="28"], :host([enable-container]).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid[enable-container][rows-xxl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="29"], :host([enable-container]).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid[enable-container][rows-xxl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="30"], :host([enable-container]).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid[enable-container][rows-xxl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="31"], :host([enable-container]).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid[enable-container][rows-xxl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="32"], :host([enable-container]).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid[enable-container][rows-xxl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="33"], :host([enable-container]).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid[enable-container][rows-xxl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="34"], :host([enable-container]).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid[enable-container][rows-xxl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="35"], :host([enable-container]).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid[enable-container][rows-xxl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="36"], :host([enable-container]).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid[enable-container][rows-xxl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="37"], :host([enable-container]).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid[enable-container][rows-xxl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="38"], :host([enable-container]).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid[enable-container][rows-xxl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="39"], :host([enable-container]).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid[enable-container][rows-xxl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="40"], :host([enable-container]).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid[enable-container][rows-xxl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="41"], :host([enable-container]).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid[enable-container][rows-xxl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="42"], :host([enable-container]).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid[enable-container][rows-xxl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="43"], :host([enable-container]).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid[enable-container][rows-xxl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="44"], :host([enable-container]).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid[enable-container][rows-xxl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="45"], :host([enable-container]).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid[enable-container][rows-xxl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="46"], :host([enable-container]).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid[enable-container][rows-xxl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="47"], :host([enable-container]).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid[enable-container][rows-xxl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="48"], :host([enable-container]).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid[enable-container][rows-xxl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="49"], :host([enable-container]).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid[enable-container][rows-xxl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="50"], :host([enable-container]).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid[enable-container][rows-xxl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xxl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Grid Gaps */
:host([gap=none]),
.ids-layout-grid.ids-layout-grid-gap-none {
  grid-gap: 0;
}

:host([gap=sm]),
.ids-layout-grid.ids-layout-grid-gap-sm {
  grid-gap: 8px;
}

:host([gap=md]),
.ids-layout-grid.ids-layout-grid-gap-md {
  grid-gap: 24px;
}

:host([gap=lg]),
.ids-layout-grid.ids-layout-grid-gap-lg {
  grid-gap: 32px;
}

:host([gap=xl]),
.ids-layout-grid.ids-layout-grid-gap-xl {
  grid-gap: 40px;
}

/* Grid Margins */
:host([margin=xs]),
.ids-layout-grid.ids-layout-grid-margin-xs {
  margin: 8px;
}

:host([margin=sm]),
.ids-layout-grid.ids-layout-grid-margin-sm {
  margin: 16px;
}

:host([margin=md]),
.ids-layout-grid.ids-layout-grid-margin-md {
  margin: 24px;
}

:host([margin=lg]),
.ids-layout-grid.ids-layout-grid-margin-lg {
  margin: 32px;
}

:host([margin=xl]),
.ids-layout-grid.ids-layout-grid-margin-xl {
  margin: 40px;
}

:host([margin=auto]),
.ids-layout-grid.ids-layout-grid-margin-auto {
  margin: auto;
}

/* Grid Margin Y */
:host([margin-y=xs]),
.ids-layout-grid.ids-layout-grid-margin-y-xs {
  margin-block: 8px;
}

:host([margin-y=sm]),
.ids-layout-grid.ids-layout-grid-margin-y-sm {
  margin-block: 16px;
}

:host([margin-y=md]),
.ids-layout-grid.ids-layout-grid-margin-y-md {
  margin-block: 24px;
}

:host([margin-y=lg]),
.ids-layout-grid.ids-layout-grid-margin-y-lg {
  margin-block: 32px;
}

:host([margin-y=xl]),
.ids-layout-grid.ids-layout-grid-margin-y-xl {
  margin-block: 40px;
}

/* Grid Max Width */
:host([max-width=xs]),
.ids-layout-grid.ids-layout-grid-max-width-xs {
  max-width: 360px;
}

:host([max-width=sm]),
.ids-layout-grid.ids-layout-grid-max-width-sm {
  max-width: 600px;
}

:host([max-width=md]),
.ids-layout-grid.ids-layout-grid-max-width-md {
  max-width: 840px;
}

:host([max-width=lg]),
.ids-layout-grid.ids-layout-grid-max-width-lg {
  max-width: 1024px;
}

:host([max-width=xl]),
.ids-layout-grid.ids-layout-grid-max-width-xl {
  max-width: 1280px;
}

:host([max-width=xxl]),
.ids-layout-grid.ids-layout-grid-max-width-xxl {
  max-width: 1440px;
}

:host([max-width$=px]) {
  max-width: var(--max-width);
}

/* Grid Padding */
:host([padding=xs]),
::slotted([padding=xs]),
.ids-layout-grid.ids-layout-grid-padding-xs {
  padding: 8px;
}

:host([padding=sm]),
::slotted([padding=sm]),
.ids-layout-grid.ids-layout-grid-padding-sm {
  padding: 16px;
}

:host([padding=md]),
::slotted([padding=md]),
.ids-layout-grid.ids-layout-grid-padding-md {
  padding: 24px;
}

:host([padding=lg]),
::slotted([padding=lg]),
.ids-layout-grid.ids-layout-grid-padding-lg {
  padding: 32px;
}

:host([padding=xl]),
::slotted([padding=xl]),
.ids-layout-grid.ids-layout-grid-padding-xl {
  padding: 40px;
}

/* Grid Padding X */
:host([padding-x=xs]),
.ids-layout-grid.ids-layout-grid-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-x=sm]),
.ids-layout-grid.ids-layout-grid-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-x=md]),
.ids-layout-grid.ids-layout-grid-padding-x-md {
  padding-inline: 24px;
}

:host([padding-x=lg]),
.ids-layout-grid.ids-layout-grid-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-x=xl]),
.ids-layout-grid.ids-layout-grid-padding-x-xl {
  padding-inline: 40px;
}

/* Grid Padding Y */
:host([padding-y=xs]),
.ids-layout-grid.ids-layout-grid-padding-y-xs {
  padding-block: 8px;
}

:host([padding-y=xxs]),
.ids-layout-grid.ids-layout-grid-padding-y-xxs {
  padding-block: 4px;
}

:host([padding-y=sm]),
.ids-layout-grid.ids-layout-grid-padding-y-sm {
  padding-block: 16px;
}

:host([padding-y=md]),
.ids-layout-grid.ids-layout-grid-padding-y-md {
  padding-block: 24px;
}

:host([padding-y=lg]),
.ids-layout-grid.ids-layout-grid-padding-y-lg {
  padding-block: 32px;
}

:host([padding-y=xl]),
.ids-layout-grid.ids-layout-grid-padding-y-xl {
  padding-block: 40px;
}

/* Grid - Auto Fit/Fill */
:host([auto-fit]),
.ids-layout-grid-auto-fit {
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(var(--min-col-width), var(--max-col-width)));
}

:host([auto-fill]),
.ids-layout-grid-auto-fill {
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(var(--min-col-width), var(--max-col-width)));
}

/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */
:host(.ids-layout-grid-cols-auto),
.ids-layout-grid-cols-auto {
  grid-auto-columns: auto;
}

:host(.ids-layout-grid-cols-min),
.ids-layout-grid-cols-min {
  grid-auto-columns: min-content;
}

:host(.ids-layout-grid-cols-max),
.ids-layout-grid-cols-max {
  grid-auto-columns: max-content;
}

:host(.ids-layout-grid-cols-fr),
.ids-layout-grid-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}

/* Grid Flow */
:host([flow=row]),
.ids-layout-grid-flow-row {
  grid-auto-flow: row;
}

:host([flow=column]),
.ids-layout-grid-flow-col {
  grid-auto-flow: column;
}

:host([flow=dense]),
.ids-layout-grid-flow-dense {
  grid-auto-flow: dense;
}

:host([flow=row-dense]),
.ids-layout-grid-flow-row-dense {
  grid-auto-flow: row dense;
}

:host([flow=column-dense]),
.ids-layout-grid-flow-col-dense {
  grid-auto-flow: column dense;
}

/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */
:host(.ids-layout-grid-auto-rows-auto),
.ids-layout-grid-auto-rows-auto {
  grid-auto-rows: auto;
}

:host(.ids-layout-grid-auto-rows-min),
.ids-layout-grid-auto-rows-min {
  grid-auto-rows: min-content;
}

:host(.ids-layout-grid-auto-rows-max),
.ids-layout-grid-auto-rows-max {
  grid-auto-rows: max-content;
}

:host(.ids-layout-grid-auto-rows-fr),
.ids-layout-grid-auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}

:host([row-height]),
.ids-layout-grid-auto-row-height {
  grid-auto-rows: var(--grid-auto-row-height);
}

/* Grid - Template Rows */
:host([template-rows]),
.ids-layout-grid-template-rows {
  grid-template-rows: var(--grid-template-rows);
}

/** Align items */
:host([align-items=start]),
.ids-layout-grid-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-grid-align-items-end {
  align-items: end;
}

:host([align-items=center]),
.ids-layout-grid-align-items-center {
  align-items: center;
}

:host([align-items=stretch]),
.ids-layout-grid-align-items-stretch {
  align-items: stretch;
}

/* Justify Content and Align Content */
:host([justify-content=start]),
.ids-layout-grid-justify-start {
  justify-content: start;
}

:host([align-content=start]),
.ids-layout-grid-align-start {
  align-content: start;
}

::slotted([justify-content=start]),
.ids-layout-grid > .ids-layout-grid-justify-start {
  display: grid;
  justify-content: start;
}

::slotted([align-content=start]),
.ids-layout-grid > .ids-layout-grid-align-start {
  display: grid;
  align-content: start;
}

:host([justify-content=center]),
.ids-layout-grid-justify-center {
  justify-content: center;
}

:host([align-content=center]),
.ids-layout-grid-align-center {
  align-content: center;
}

::slotted([justify-content=center]),
.ids-layout-grid > .ids-layout-grid-justify-center {
  display: grid;
  justify-content: center;
}

::slotted([align-content=center]),
.ids-layout-grid > .ids-layout-grid-align-center {
  display: grid;
  align-content: center;
}

:host([justify-content=space-between]),
.ids-layout-grid-justify-space-between {
  justify-content: space-between;
}

:host([align-content=space-between]),
.ids-layout-grid-align-space-between {
  align-content: space-between;
}

::slotted([justify-content=space-between]),
.ids-layout-grid > .ids-layout-grid-justify-space-between {
  display: grid;
  justify-content: space-between;
}

::slotted([align-content=space-between]),
.ids-layout-grid > .ids-layout-grid-align-space-between {
  display: grid;
  align-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-grid-justify-space-around {
  justify-content: space-around;
}

:host([align-content=space-around]),
.ids-layout-grid-align-space-around {
  align-content: space-around;
}

::slotted([justify-content=space-around]),
.ids-layout-grid > .ids-layout-grid-justify-space-around {
  display: grid;
  justify-content: space-around;
}

::slotted([align-content=space-around]),
.ids-layout-grid > .ids-layout-grid-align-space-around {
  display: grid;
  align-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-grid-justify-space-evenly {
  justify-content: space-evenly;
}

:host([align-content=space-evenly]),
.ids-layout-grid-align-space-evenly {
  align-content: space-evenly;
}

::slotted([justify-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-justify-space-evenly {
  display: grid;
  justify-content: space-evenly;
}

::slotted([align-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-align-space-evenly {
  display: grid;
  align-content: space-evenly;
}

:host([justify-content=end]),
.ids-layout-grid-justify-end {
  justify-content: end;
}

:host([align-content=end]),
.ids-layout-grid-align-end {
  align-content: end;
}

::slotted([justify-content=end]),
.ids-layout-grid > .ids-layout-grid-justify-end {
  display: grid;
  justify-content: end;
}

::slotted([align-content=end]),
.ids-layout-grid > .ids-layout-grid-align-end {
  display: grid;
  align-content: end;
}

/* Grid Col/Row Span All and Sticky */
::slotted([col-span=all]),
.ids-layout-grid > .ids-layout-grid-col-span-all {
  grid-column: 1/-1;
}

::slotted([row-span=all]),
.ids-layout-grid > .ids-layout-grid-row-span-all {
  grid-row: 1/-1;
}

::slotted([sticky]),
.ids-layout-grid > .ids-layout-grid-sticky {
  position: sticky;
  top: var(--sticky-position);
}

/* Hide Cell on Breakpoints */
:host > ::slotted([hide=xs]) {
  display: none;
}

:host > ::slotted([hide=sm]) {
  display: none;
}

:host > ::slotted([hide=md]) {
  display: none;
}

:host > ::slotted([hide=lg]) {
  display: none;
}

:host > ::slotted([hide=xl]) {
  display: none;
}

:host > ::slotted([hide=xxl]) {
  display: none;
}

/* Editable */
::slotted([editable]) > ids-button,
.ids-layout-grid > .ids-layout-grid-cell.editable > ids-button {
  position: absolute;
  top: 0;
  right: 0;
}

/* Fill */
::slotted([fill]),
.ids-layout-grid > .ids-layout-grid-cell.fill {
  background-color: var(--grid-fill-color);
  color: var(--grid-text-color);
}

/* Height */
::slotted([height=auto]),
.ids-layout-grid > .ids-layout-grid-height-auto {
  height: auto;
}`;var a=class extends c{set alignContent(o){!o||l.indexOf(o)<=0?this.removeAttribute(t.ALIGN_CONTENT):this.setAttribute(t.ALIGN_CONTENT,o)}get alignContent(){return this.getAttribute(t.ALIGN_CONTENT)}set alignItems(o){!o||m.indexOf(o)<0?this.removeAttribute(t.ALIGN_ITEMS):this.setAttribute(t.ALIGN_ITEMS,o)}get alignItems(){return this.getAttribute(t.ALIGN_ITEMS)}set autoFit(o){r(o)?this.setAttribute(t.AUTO_FIT,""):this.removeAttribute(t.AUTO_FIT)}get autoFit(){return r(this.getAttribute(t.AUTO_FIT))}set autoFill(o){r(o)?this.setAttribute(t.AUTO_FILL,""):this.removeAttribute(t.AUTO_FILL)}get autoFill(){return r(this.getAttribute(t.AUTO_FILL))}set cols(o){o!==null?this.setAttribute(t.COLS,o):this.removeAttribute(t.COLS)}get cols(){return this.getAttribute(t.COLS)}set colsXs(o){o!==null?this.setAttribute(t.COLS_XS,o):this.removeAttribute(t.COLS_XS)}get colsXs(){return this.getAttribute(t.COLS_XS)}set colsSm(o){o!==null?this.setAttribute(t.COLS_SM,o):this.removeAttribute(t.COLS_SM)}get colsSm(){return this.getAttribute(t.COLS_SM)}set colsMd(o){o!==null?this.setAttribute(t.COLS_MD,o):this.removeAttribute(t.COLS_MD)}get colsMd(){return this.getAttribute(t.COLS_MD)}set colsLg(o){o!==null?this.setAttribute(t.COLS_LG,o):this.removeAttribute(t.COLS_LG)}get colsLg(){return this.getAttribute(t.COLS_LG)}set colsXl(o){o!==null?this.setAttribute(t.COLS_XL,o):this.removeAttribute(t.COLS_XL)}get colsXl(){return this.getAttribute(t.COLS_XL)}set colsXxl(o){o!==null?this.setAttribute(t.COLS_XXL,o):this.removeAttribute(t.COLS_XXL)}get colsXxl(){return this.getAttribute(t.COLS_XXL)}set minColWidth(o){o!==null?(this.setAttribute(t.MIN_COL_WIDTH,o),this.style.setProperty("--min-col-width",o)):(this.removeAttribute(t.MIN_COL_WIDTH),this.style.removeProperty("--min-col-width"))}get minColWidth(){return this.getAttribute(t.MIN_COL_WIDTH)}set minRowHeight(o){o!==null?(this.setAttribute(t.MIN_ROW_HEIGHT,o),this.style.setProperty("--min-row-height",o)):(this.removeAttribute(t.MIN_ROW_HEIGHT),this.style.removeProperty("--min-row-height"))}get minRowHeight(){return this.getAttribute(t.MIN_ROW_HEIGHT)}set maxColWidth(o){o!==null?(this.setAttribute(t.MAX_COL_WIDTH,o),this.style.setProperty("--max-col-width",o)):(this.removeAttribute(t.MAX_COL_WIDTH),this.style.removeProperty("--max-col-width"))}get maxColWidth(){return this.getAttribute(t.MAX_COL_WIDTH)}set maxRowHeight(o){o!==null?(this.setAttribute(t.MAX_ROW_HEIGHT,o),this.style.setProperty("--max-row-height",o)):(this.removeAttribute(t.MAX_ROW_HEIGHT),this.style.removeProperty("--max-row-height"))}get maxRowHeight(){return this.getAttribute(t.MAX_ROW_HEIGHT)}set gap(o){!o||x.indexOf(o)<=0?this.removeAttribute(t.GAP):this.setAttribute(t.GAP,o)}get gap(){return this.getAttribute(t.GAP)}set margin(o){!o||s.indexOf(o)<=0?this.removeAttribute(t.MARGIN):this.setAttribute(t.MARGIN,o)}get margin(){return this.getAttribute(t.MARGIN)}set marginY(o){!o||s.indexOf(o)<=0?this.removeAttribute(t.MARGIN_Y):this.setAttribute(t.MARGIN_Y,o)}get marginY(){return this.getAttribute(t.MARGIN_Y)}set maxWidth(o){!o||h.indexOf(o)<=0?(this.removeAttribute(t.MAX_WIDTH),o?.endsWith("px")&&(this.style.setProperty("--max-width",o),this.setAttribute(t.MAX_WIDTH,o))):(this.setAttribute(t.MAX_WIDTH,o),this.style.removeProperty("--max-width"))}get maxWidth(){return this.getAttribute(t.MAX_WIDTH)}set padding(o){!o||n.indexOf(o)<=0?this.removeAttribute(t.PADDING):this.setAttribute(t.PADDING,o)}get padding(){return this.getAttribute(t.PADDING)}set paddingX(o){!o||n.indexOf(o)<=0?this.removeAttribute(t.PADDING_X):this.setAttribute(t.PADDING_X,o)}get paddingX(){return this.getAttribute(t.PADDING_X)}set paddingY(o){!o||n.indexOf(o)<=0?this.removeAttribute(t.PADDING_Y):this.setAttribute(t.PADDING_Y,o)}get paddingY(){return this.getAttribute(t.PADDING_Y)}set justifyContent(o){!o||l.indexOf(o)<=0?this.removeAttribute(t.JUSTIFY_CONTENT):this.setAttribute(t.JUSTIFY_CONTENT,o)}get justifyContent(){return this.getAttribute(t.JUSTIFY_CONTENT)}set flow(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW):this.setAttribute(t.FLOW,o)}get flow(){return this.getAttribute(t.FLOW)}set flowXs(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_XS):this.setAttribute(t.FLOW_XS,o)}get flowXs(){return this.getAttribute(t.FLOW_XS)}set flowSm(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_SM):this.setAttribute(t.FLOW_SM,o)}get flowSm(){return this.getAttribute(t.FLOW_SM)}set flowMd(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_MD):this.setAttribute(t.FLOW_MD,o)}get flowMd(){return this.getAttribute(t.FLOW_MD)}set flowLg(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_LG):this.setAttribute(t.FLOW_LG,o)}get flowLg(){return this.getAttribute(t.FLOW_LG)}set flowXl(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_XL):this.setAttribute(t.FLOW_XL,o)}get flowXl(){return this.getAttribute(t.FLOW_XL)}set flowXxl(o){!o||d.indexOf(o)<=0?this.removeAttribute(t.FLOW_XXL):this.setAttribute(t.FLOW_XXL,o)}get flowXxl(){return this.getAttribute(t.FLOW_XXL)}set height(o){if(o!==null){let i=/^\d+(\.\d+)?$/g.test(o)?`${o}px`:o;this.setAttribute(t.HEIGHT,i),this.style.setProperty(t.HEIGHT,i)}else this.removeAttribute(t.HEIGHT),this.style.removeProperty(t.HEIGHT)}get height(){return this.getAttribute(t.HEIGHT)}set rows(o){o!==null?this.setAttribute(t.ROWS,o):this.removeAttribute(t.ROWS)}get rows(){return this.getAttribute(t.ROWS)}set rowsXs(o){o!==null?this.setAttribute(t.ROWS_XS,o):this.removeAttribute(t.ROWS_XS)}get rowsXs(){return this.getAttribute(t.ROWS_XS)}set rowsSm(o){o!==null?this.setAttribute(t.ROWS_SM,o):this.removeAttribute(t.ROWS_SM)}get rowsSm(){return this.getAttribute(t.ROWS_SM)}set rowsMd(o){o!==null?this.setAttribute(t.ROWS_MD,o):this.removeAttribute(t.ROWS_MD)}get rowsMd(){return this.getAttribute(t.ROWS_MD)}set rowsLg(o){o!==null?this.setAttribute(t.ROWS_LG,o):this.removeAttribute(t.ROWS_LG)}get rowsLg(){return this.getAttribute(t.ROWS_LG)}set rowsXl(o){o!==null?this.setAttribute(t.ROWS_XL,o):this.removeAttribute(t.ROWS_XL)}get rowsXl(){return this.getAttribute(t.ROWS_XL)}set rowsXxl(o){o!==null?this.setAttribute(t.ROWS_XXL,o):this.removeAttribute(t.ROWS_XXL)}get rowsXxl(){return this.getAttribute(t.ROWS_XXL)}set rowHeight(o){o!==null?(this.setAttribute(t.ROW_HEIGHT,o),this.classList.add(`${e}-auto-row-height`),this.style.setProperty("--grid-auto-row-height",o)):(this.removeAttribute(t.ROW_HEIGHT),this.classList.remove(`${e}-auto-row-height`),this.style.removeProperty("--grid-auto-row-height"))}get rowHeight(){return this.getAttribute(t.ROW_HEIGHT)}set templateRows(o){o!==null?(this.setAttribute(t.TEMPLATE_ROWS,o),this.classList.add(`${e}-template-rows`),this.style.setProperty("--grid-template-rows",o)):(this.removeAttribute(t.TEMPLATE_ROWS),this.classList.remove(`${e}-template-rows`),this.style.removeProperty("--grid-template-rows"))}get templateRows(){return this.getAttribute(t.TEMPLATE_ROWS)}set enableContainer(o){r(o)?(this.setAttribute(t.ENABLE_CONTAINER,""),this.classList.add(t.ENABLE_CONTAINER)):(this.removeAttribute(t.ENABLE_CONTAINER),this.classList.remove(t.ENABLE_CONTAINER))}get enableContainer(){return this.hasAttribute(t.ENABLE_CONTAINER)}constructor(){super()}static get attributes(){return b}connectedCallback(){super.connectedCallback(),this.initialSettings()}initialSettings(){this.classList.add(`${e}`)}template(){return"<slot></slot>"}};a=g([u("ids-layout-grid"),y(p)],a);export{a};
